<template>
  <v-content class="bg-content">
    <div class="about card-animate-2">
      <v-container grid-list-xl style="padding: 5px; top: 80px;">
        <v-layout row wrap>
          <v-flex sm3 xs3 md4 lg3>
            <v-card
              elevation="3"
              class="chart-content"
              target="_self"
              style="height: 260px; width: 100%; align-items: center; justify-content: center; display: flex; flex-direction: column; border-radius: 20px;"
            >
              <div class="chart-title-2">Sale Leads</div>
              <div class="chart-text">{{ this.dashboard.leads }}</div>
            </v-card>
          </v-flex>
          <v-flex sm3 xs3 md4 lg9>

            <div class="card-animate-2">
      <v-container grid-list-xl style="padding: 10px; top: -70px; border-radius: 80px;">

          <v-app-bar
            color="rgba(12, 22, 27, 0.9)"
            max-height="75"
            height="75"
            elevation="3"
            dense
            dark
          >
        <v-toolbar-title>
          <v-avatar size="40">
            <img src="@/assets/SalesIcon.png" />
          </v-avatar>
          Sales
        </v-toolbar-title>

               <v-spacer></v-spacer>

        <div>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
            dense
            outlined
            class="mr-1"
            v-on:change="searchVendor"
          ></v-text-field>
        </div>

        <v-btn
          class="ma-2"
          outlined
          color="white"
          value="Go Back From Whence You Came!"
          onclick="history.back(-1)"
          >Previous</v-btn
        >

        <v-btn
          elevation="2"
          outlined
          dark
          depressed
          color="white"
          @click="openForm"
          >Create</v-btn
        >
          </v-app-bar>

          <v-data-table
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            class="theme-bg-card-2"
            :loading="tableLoader"
            loading-text="Loading... Please wait"
            :headers="headers"
            :items="purchaseordersList"
            :search="search"
            max-width="750"
            id="virtual-scroll-table"
            v-scroll:#virtual-scroll-table="onScroll"
          >
            <template v-slot:item.controls="props">
              <i
                class="fa fa-trash thrash"
                @click="deleteConfirmation(props.item)"
              ></i>
              <i
                class="fa fa-pencil thrash"
                @click="editPurchaseOrder(props.item)"
                style="margin-left: 20px"
              ></i>
            </template>
          </v-data-table>
      </v-container>



<v-flex sm12 xs12 md12 lg12>

<!-- <iframe ref="outputIframe"
src="https://play.viostream.com/iframe/s0m3m3d14?playerKey=s0m3p14y3r"
frameborder="0" allowfullscreen="" style="position:relative; top:0; left: 0">
</iframe> -->

<iframe ref="outputIframe" frameborder="0" class="data-table-iframe" style="margin-left: 100px; margin-top: 100px; width: 90%; padding-block: 20px;"></iframe>


<!-- <iframe ref="outputIframe" frameborder="0" class="default-size" style="margin-left: 90px; margin-bottom: 50px; width: 90%; height: 500px;"></iframe> -->
  </v-flex>

<v-flex sm12 xs12 md12 lg12>

<bar-chart style="margin-left: 100px; margin-top: 50px; margin-bottom: 150px; width: 88%; padding-block: 20px;" ref="salesChart" v-if="reportType === 'Sales Report'"></bar-chart>
<bar-chart style="margin-left: 100px; margin-top: 50px; margin-bottom: 150px; width: 88%; padding-block: 20px;" ref="profitMarginsChart" v-if="reportType === 'Profit Margins Report'"></bar-chart>
<bar-chart style="margin-left: 100px; margin-top: 50px; margin-bottom: 150px; width: 88%; padding-block: 20px;" ref="invoiceOwnerChart" v-if="reportType === 'Invoice Owner Report'"></bar-chart>
<bar-chart style="margin-left: 100px; margin-top: 50px; margin-bottom: 150px; width: 88%; padding-block: 20px;" ref="invoiceOwnerScoreboardChart" v-if="reportType === 'Invoice Owner Scoreboard Report'"></bar-chart>

</v-flex>



    </div>
    </v-flex> 

          

        </v-layout>
      </v-container>
    </div>
    <div class="card-animate-2">
      <!-- <v-container grid-list-xl style="padding: 10px; top: 50px">
        <v-card dark class="theme-bg-card-2">
          <v-app-bar
            color="rgba(12, 22, 27, 0.9)"
            max-height="75"
            height="75"
            elevation="3"
            dense
            dark
          >
        <v-toolbar-title>
          <v-avatar size="40">
            <img src="@/assets/SalesIcon.png" />
          </v-avatar>
          Sales
        </v-toolbar-title>

               <v-spacer></v-spacer>

        <div>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
            dense
            outlined
            class="mr-1"
            v-on:change="searchVendor"
          ></v-text-field>
        </div>

        <v-btn
          class="ma-2"
          outlined
          color="white"
          value="Go Back From Whence You Came!"
          onclick="history.back(-1)"
          >Previous Page</v-btn
        >

        <v-btn
          elevation="2"
          outlined
          dark
          depressed
          color="white"
          @click="openForm"
          >Create</v-btn
        >
          </v-app-bar>

          <v-data-table
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            class="theme-bg-card-2"
            :loading="tableLoader"
            loading-text="Loading... Please wait"
            :headers="headers"
            :items="purchaseordersList"
            :search="search"
            max-width="750"
            id="virtual-scroll-table"
            v-scroll:#virtual-scroll-table="onScroll"
          >
            <template v-slot:item.controls="props">
              <i
                class="fa fa-trash thrash"
                @click="deleteConfirmation(props.item)"
              ></i>
              <i
                class="fa fa-pencil thrash"
                @click="editPurchaseOrder(props.item)"
                style="margin-left: 20px"
              ></i>
            </template>
          </v-data-table>
        </v-card>
      </v-container> -->

      <v-container class="card-animate-2" style="top: 30px; padding-left: 0px; padding-right: 50px; padding-bottom: 50px; margin-left: 80px; margin-bottom: 150px;  margin-top: 300px;">         
      <h3>Sales Reports</h3>

      <v-divider></v-divider>

<v-row>
<v-menu
  v-model="menuStartDate"
  :close-on-content-click="false"
  :nudge-right="20"
  :nudge-top="-20"
  transition="scale-transition"
  offset-y
  min-width="130px"
>
  <template v-slot:activator="{ on }">
    <v-text-field
      v-model="startDate"
      label="Start date"
      append-icon="mdi-calendar"
      v-on="on"
      cursor="pointer"
    ></v-text-field>
  </template>
  <v-date-picker v-model="startDate" @input="menuStartDate = false"></v-date-picker>
</v-menu>

<v-menu
  v-model="menuEndDate"
  :close-on-content-click="false"
  :nudge-right="20"
  :nudge-top="-20"
  transition="scale-transition"
  offset-y
  min-width="130px"
>
  <template v-slot:activator="{ on }">
    <v-text-field
      v-model="endDate"
      label="End date"
      append-icon="mdi-calendar"
      v-on="on"
      cursor="pointer"
    ></v-text-field>
  </template>
  <v-date-picker v-model="endDate" @input="menuEndDate = false"></v-date-picker>
</v-menu>

<v-menu
transition="scale-transition"
offset-y
min-width="130px"
>
<template v-slot:activator="{ on: menuOn }">
  <v-text-field
    v-model="reportType"
    label="Report Type"
    append-icon="mdi-chevron-down"
    v-on="{ ...on, ...menuOn }"
  ></v-text-field>
</template>
<v-list>
  <v-list-item
    v-for="(item, index) in ['Sales Report', 'Profit Margins Report', 'Invoice Owner Report', 'Invoice Owner Scoreboard Report', 'Scoreboard Report']"
    :key="index"
    @click="reportType = item"
  >
    <v-list-item-title>{{ item }}</v-list-item-title>
  </v-list-item>
</v-list>
</v-menu>



<button ref="Btn" @click="generateScoreboardReport"></button>

<v-btn class=" button ma-2" color="primary" @click="generateReport">Report</v-btn>
<transition name="slide-fade">
  <v-btn v-if="reportGenerated" class="button ma-2" color="primary" @click="downloadReport">
    Download Report
  </v-btn>
</transition>

    <!-- <v-btn class="ma-3" color="primary" @click="generateReport">Generate Report</v-btn>
    <v-btn
    class="ma-3"
    color="primary"
    @click="downloadReport"
  >
    Download Report
  </v-btn> -->
  <!-- <v-col>
    <v-select
  v-model="selectedFields"
  :items="availableFields"
  label="Fields to include"
  multiple
  chips
></v-select>
  </v-col>
  <v-col>
    <v-select
      v-model="activeFilters"
      :items="generatedFilters"
      label="Active Filters"
      multiple
    ></v-select>
  </v-col>
  <v-col>
  <v-checkbox
    v-model="selectAll"
    label="Select All"
    @change="selectAllInvoices"
  ></v-checkbox>
</v-col> -->
<v-col>
<v-btn
class="ma-3"
color="primary"
@click="generateReport"
>
Generate Report
</v-btn>
</v-col>
</v-row>
</v-container>
<br />
<br />
<v-divider></v-divider>
<v-container fluid grid-list-xl style="margin-top: 300px;">
<v-flex sm12 xs12 md12 lg12>

  <table 
  class="blueTable">
    <thead>
      <tr>
        <th>Leader</th>
        <th>Agent</th>
        <th>Products Sold</th>
        <th>Total Sales Leads</th>
        <th>Achieved Goal</th>
      </tr>
    </thead>
    <tbody id="scoreboardTableBody">
      <tr v-for="(owner, index) in sortedInvoiceOwners" 
          :key="index"
          v-bind:class="{'first-place': index === 0, 'second-place': index === 1, 'third-place': index === 2, 'fourth-place' : index === 3, 'fifth-place': index === 4, 'sixth-place': index === 5, 'seventh-place' : index === 6, 'eighth-place' : index === 7, 'ninth-place' : index === 8}"
      >
          <td>{{ index + 1 }}</td>
          <td>{{ owner }}</td>
          <td>{{ ownerData[owner].totalQuantity }}</td>
          <td>{{ ownerData[owner].totalInvoices }}</td>
          <td>
              <img style="width: 38px; height: 38px; margin-left: 10px; margin-right: 10px; margin-bottom: 3px; margin-top: 3px;"  
                  :src="ownerData[owner].totalInvoices == 0 ? dataZero : ownerData[owner].goalCompleted" 
                  alt="Goal Status"
              />
          </td>
      </tr>
  </tbody>
  </table>

</v-flex>
</v-container>


 <v-flex sm4 xs4 md4 lg12>
   <iframe ref="outputIframe" frameborder="0" class="data-table-iframe" style="margin-left: 110px; margin-top: 200px; width: 86.2%; padding-block: 20px;"></iframe>
 </v-flex>

 <v-flex sm4 xs4 md4 lg12>

<bar-chart style="margin-left: 100px; margin-top: 50px; margin-bottom: 150px; width: 87%; padding-block: 20px;" ref="salesChart" v-if="reportType === 'Sales Report'"></bar-chart>
<bar-chart style="margin-left: 100px; margin-top: 50px; margin-bottom: 150px; width: 87%; padding-block: 20px;" ref="profitMarginsChart" v-if="reportType === 'Profit Margins Report'"></bar-chart>
<bar-chart style="margin-left: 100px; margin-top: 50px; margin-bottom: 150px; width: 87%; padding-block: 20px;" ref="invoiceOwnerChart" v-if="reportType === 'Invoice Owner Report'"></bar-chart>
<bar-chart style="margin-left: 100px; margin-top: 50px; margin-bottom: 150px; width: 87%; padding-block: 20px;" ref="invoiceOwnerScoreboardChart" v-if="reportType === 'Invoice Owner Scoreboard Report'"></bar-chart>

</v-flex>
    </div>

    <v-dialog v-model="showConfirmation" max-width="600">
      <v-card class="theme-bg-card-8">
        <v-card-title class="text-h5">
          Are you sure you want to delete this sales lead?
        </v-card-title>

        <v-card-text :v-if="itemToBeDeleted._id">
          Sales Lead: {{ itemToBeDeleted.vendorName }}
          {{ itemToBeDeleted.vendorType }}
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="green darken-1"
            text
            @click="showConfirmation = false"
          >
            Disagree
          </v-btn>

          <v-btn
            color="green darken-1"
            text
            :loading="loading3"
            :disabled="loading3"
            @click="deletePurchaseOrder(), deleteLead(), deleteOpportunity()"
            v-on:keyup.enter="deletePurchaseOrder(), deleteLead(), deleteOpportunity()"
          >
            Agree
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <v-dialog v-model="showEmailConfirmation" max-width="620" max-height="100">
      <v-card class="theme-bg-card-4">
            <v-toolbar-title style="padding: 16px;">
              <v-avatar size="60">
                <img src="@/assets/EmailIcon.png" />
              </v-avatar>
            </v-toolbar-title>
        <v-spacer></v-spacer><v-spacer></v-spacer>
  <h1 class="user-speach">
    <v-flex class="space" />   
    <h1 class="typing2">
      <span>{{ speak }}</span>
    </h1>
  </h1>

      </v-card>
    </v-dialog>


    <v-overlay :value="overlay" opacity="0.98" z-index="9">
      <v-card
        v-scroll.self="onScroll"
        class="overflow-y-auto popup-container theme-bg-card-sales"
      >
        <v-layout row wrap fluid>
          <v-flex xs12 sm12 md12>
            <v-list-item class="mb-margin">
              <v-list-item-content>
                <v-form
                
                  lazy-validation
                  aria-autocomplete="off"
                >
                  <v-banner
                    class="justify-center text-h5 font-weight-light"
                    sticky
                  >
                    <v-avatar size="70">
                      <img src="@/assets/SalesIcon.png" />
                    </v-avatar>
                    Sales Lead
                  </v-banner>
                  <br />
                  <div class="formBG">
                  <h4 class="display-6 font-weight-thin">
                    General Information
                  </h4>
                  <v-row>
                    <v-select
                      v-model="formFields.leadStatus"
                      class="mg-lr14"
                      :items="leadStatus"
                      hint="Cancel, Rejected, Follow up...."
                      label="Sales Lead Status"
                      outlined
                    ></v-select>
                    <input
                        type="date"
                        v-model="formFields.leadsDate"
                        class="date-picker-2 mg-lr14"
                      />
                  </v-row>
                  <v-row>
                    <v-select
                      class="mg-lr14"
                      v-model="formFields.leadOwner"
                      :items="leadOwner"
                      label="Sales Lead Owner"
                      outlined
                    ></v-select>
                    <v-select
                      class="mg-lr14"
                      v-model="formFields.salesAgent"
                      :items="salesAgent"
                      label="Sales Agent"
                      outlined
                    ></v-select>
    
                    </v-row>
                  <v-row>
                    <v-text-field
                      style="flex: 1"
                      v-model="formFields.company"
                      class="mg-lr14"
                      label="Company Name"
                      outlined
                    ></v-text-field>
                    <v-text-field
                      style="flex: 1"
                      v-model="formFields.title"
                      class="mg-lr14"
                      label="Title"
                      outlined
                    ></v-text-field>
                  </v-row>
                  <v-row>
                    <v-text-field
                      v-model="formFields.firstName"
                      class="mg-lr14"
                      label="First Name"
                      outlined
                      required
                    ></v-text-field>
                    <v-text-field
                      v-model="formFields.lastName"
                      class="mg-lr14"
                      label="Last Name"
                      outlined
                      required
                    ></v-text-field>
                  </v-row>
                  <v-row>
                    <v-text-field
                      style="flex: 1"
                      v-model="formFields.phone"
                      class="mg-lr14"
                      label="Phone"
                      outlined
                    ></v-text-field>
                    <v-btn color="primary" @click="callFirstPhone">Call</v-btn>
                    <v-text-field
                      style="flex: 1"
                      v-model="formFields.secondPhone"
                      class="mg-lr14"
                      label="Second Phone"
                      outlined
                    ></v-text-field>
                    <v-btn color="primary" @click="callSecondPhone">Call</v-btn>
                  </v-row>
                  <v-row>
                    <v-text-field
                      class="mg-lr14"
                      v-model="formFields.email"
                      label="Email"
                      outlined
                      required
                    ></v-text-field>
                    <v-text-field
                      class="mg-lr14"
                      v-model="formFields.secondaryEmail"
                      label="Secondary Email"
                      outlined
                      required
                    ></v-text-field>
                  </v-row>
                  <v-row>
                    <v-text-field
                      class="mg-lr14"
                      v-model="formFields.propertyManagement"
                      label="Property Management"
                      outlined
                      required
                    ></v-text-field>
                  </v-row>
                  </div>

                  <h4 class="display-6 font-weight-thin">Address</h4>
                  <v-row>
                    <v-text-field
                      v-model="formFields.street"
                      class="mg-lr14"
                      label="Street"
                      outlined
                      required
                    ></v-text-field>
                    <v-text-field
                      v-model="formFields.city"
                      class="mg-lr14"
                      label="City"
                      outlined
                      required
                    ></v-text-field>
                  </v-row>

                  <v-row>
                    <v-text-field
                      class="mg-lr14"
                      v-model="formFields.state"
                      label="State"
                      outlined
                      required
                    ></v-text-field>
                    <v-text-field
                      class="mg-lr14"
                      v-model="formFields.zipcode"
                      label="Zip Code"
                      outlined
                      required
                    ></v-text-field>
                  </v-row>
                  <br />
                  <div class="formBG">
                  <h4 class="display-6 font-weight-thin">
                    Follow Up
                  </h4>
                  <v-row>
                    <v-text-field
                      v-model="formFields.quantity"
                      class="mg-lr14"
                      label="Number of Guards"
                      outlined
                      required
                    ></v-text-field>
                    <v-text-field
                      v-model="formFields.quantityStops"
                      class="mg-lr14"
                      label="Number of Stops"
                      outlined
                      required
                    ></v-text-field>
                    <v-select
    v-model="formFields.serviceType"
    :items="['On Site Guard', 'Patrol Service']"
    label="Service Type"
    required
    class="mg-lr14"
    outlined
  ></v-select>
</v-row>
<!-- <v-row style="padding-left: 20px; padding-right: 20px;">
<v-flex xs6 sm6 md6 lg3 xl3>
<label for="startTime">Start Time:</label>
<input
  id="startTime"
  v-model="formFields.startTime"
  type="time"
  required
  class="mg-lr14"
  outlined
/>
</v-flex>
<v-flex xs6 sm6 md6 lg3 xl3>

<label for="endTime">End Time:</label>
<input
  id="endTime"
  v-model="formFields.endTime"
  type="time"
  required
  class="mg-lr14"
  outlined
/>
</v-flex>
<v-flex xs6 sm6 md6 lg3 xl3>
<p>Total service hours: {{ serviceHours }}</p>
</v-flex>

</v-row> -->

<v-row>
<v-text-field
  v-model="formFields.standingGuardRate"
  label="Standing Guard Rate"
  placeholder="e.g. 15.00"
  type="number"
  prefix="$"
  class="mg-lr14"
  outlined
></v-text-field>

<v-text-field
  v-model="formFields.ratePerStop"
  label="Rate per Stop"
  placeholder="e.g. 10.00"
  type="number"
  prefix="$"
  class="mg-lr14"
  outlined
></v-text-field>
</v-row>
<v-row>
  <!-- Service Description -->
  <v-textarea
    v-model="formFields.description"
    label="Description"
    required
    class="mg-lr14"
    outlined
    auto-grow
  ></v-textarea>

                  </v-row>
                  </div>  
               
                  <h4 class="display-6 font-weight-thin">
                    Details
                  </h4>

                  <div>
                    <div
                      v-for="(input, k) in inputs"
                      :key="k"
                      style="width: 100%; margin-left:0px; padding: 20px; margin-bottom: 25px; border-radius: 15px; border: 2px solid rgba(187,213,77,.2);"
                    >
        <v-layout row wrap>
          <v-flex sm4 xs4 md4 lg3>
               <div class="form-title">Called</div>
                    <input
                        type="date"
                        v-model="input.callDate"
                        class="date-picker"
                      />
          </v-flex>
          <v-flex sm4 xs4 md4 lg6>
               <div class="form-title">Notes</div>
                      <input
                        type="text"
                        placeholder="Notes"
                        class="form-control-2"
                        v-model="input.notes"
                        textarea
                        style="margin-top: 10px; width: 100%; height: 70px; border-radius: 15px; border: 2px solid rgba(120,181,156,.2);"
                      />
          </v-flex>
          <v-flex sm4 xs4 md4 lg3>
               <div class="form-title">Follow Up</div>
                    <input
                        type="date"
                        v-model="input.callbackDate"
                        class="date-picker"
                      />
          </v-flex>
        </v-layout>
                      <span style="margin-left: 10px" class="d-flex-row">
                        <i
                          class="fa fa-trash action-btn"
                          @click="remove(k)"
                          v-show="k || (!k && inputs.length > 1)"
                        ></i>
                        <i
                          style="margin-left: 10px"
                          class="fa fa-plus-circle action-btn"
                          @click="add(k)"
                          v-show="k == inputs.length - 1"
                        ></i>
                      </span>
                    </div>
                  </div>
                  <v-card
                    dark
                    class="theme-bg-card-5 card-animate"
                   >  

               <v-form
                  ref="invoiceform"
                  lazy-validation
                  aria-autocomplete="off"
                  class="form-control-2"
                >
            
                  <form ref="form" @submit.prevent="sendEmail">

                  <v-row fluid>

<v-button class="button">
            <v-toolbar-title style="padding: 0px;">
              <v-avatar size="60">
                <img src="@/assets/EmailIcon.png" />
              </v-avatar>
                  Sales Lead Email
            </v-toolbar-title>
                  <div class="field">
                  <label>Name</label>
                  <input type="text" v-model="formFields.vendorName" name="user_name">
                  <label>Email</label>
                  <input type="email" v-model="formFields.email" name="user_email">
                  <input class="submit" type="submit" @click="submitForm2" value="Send">
                  <span class="submit"></span>
                  <span class="loading"><i class="fa fa-spinner fa-spin"></i></span>
                  <span class="check"><i class="fa fa-check"></i></span>
                  </div>
                  </v-button>
                  </v-row>

                  </form>                
                </v-form>

                  </v-card>



                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      class="mx-2"
                      color="red"
                      outlined
                      @click="resetForm()"
                      >Cancel</v-btn
                    >
                    <!-- <v-btn
                      class="mx-2"
                      color="green"
                      :loading="loading3"
                      :disabled="loading3"
                      outlined
                      @click="submitForm"
                      >Save</v-btn> -->
                      <!-- <v-btn
                      class="mx-2"
                      color="green"
                      v-if="!editForm"
                      :loading="loading3"
                      :disabled="loading3"
                      outlined
                      @click="submitForm3"
                      >Save</v-btn> -->

                    <v-btn
                      class="mx-2"
                      color="green"
                      :loading="loading4"
                      :disabled="loading4"
                      outlined
                      @click="submitForm3"
                      >Save</v-btn
                    >
                    <v-btn
                      class="mx-2"
                      color="green"
                      :loading="loading4"
                      :disabled="loading4"
                      outlined
                      @click="submitForm4"
                      >Convert to Opportunity</v-btn
                    >
                    <v-btn
                      class="mx-2"
                      color="green"
                      v-if="editForm"
                      :loading="loading3"
                      :disabled="loading3"
                      outlined
                      @click="updatePurchaseOrder"
                      >Update</v-btn
                    >
                  </v-card-actions>
                </v-form>
              </v-list-item-content>
            </v-list-item>
          </v-flex>
        </v-layout>
      </v-card>
    </v-overlay>
  </v-content>
</template>

<script>
import easyinvoice from 'easyinvoice';
import dateCommand from '../utility';
import emailjs from '@emailjs/browser';
import goalAchieved from '@/assets/goalAchievednew.png';
import goalFailed from '@/assets/goalNotAchievednew.png';
import dataZero from '@/assets/dataZero.png';
import startAudio from '@/assets/audio/SalesBell.wav';

export default {
name: 'Sales',
components: {
},
data() {
  return {
    goalAchieved,
    goalFailed,
    dataZero,
    sortBy: 'fat',
    sortDesc: false,
    scrollInvoked: 0,
    leadOwner: [
      'Jose Luis Flores',
      'Angel Alvarado',
    ],
    salesAgent: [
      'Sadik Nomair',
    ],
    accountOptions: [
      'Client',
      'Partner',
    ],
    leadStatus: [
        'Cancel',
        'Rejected',
        'Follow up Schedule',
        'Officer Assignee',
        'Appointment',
        'Proposal',
        'Pending',
        'Cancel',
        'Close Contract',
        'Do not Call',
      ],
    dashboard: {},
    accountType: [
    'Business',
    'Personal',
    'Non-Profit',
  ],
    vendorType: ['Individual', 'Business', 'Retail', 'Online', 'Wholesale', 'Partner'],
    vendorStatus: ['Pending', 'Created', 'Canceled', 'New'],
    items: [],
    contact_list: [],
    vendor_list: [],
    vendorsList: [],
    purchaseordersList: [],
    productsList: [],
    searchKey: '',
    search: '',
    speak: '',
    micOn: false,
    dialog: false,
    requestType: '',
    currentRoute: '',
    userInfo: {},
    mtype: null,
    media: null,
    searchVendorName: '',
    searchContactName: '',
    showVendorForm: false,
    showContactForm: false,
    showEmailConfirmation: false,
    optionIndex: 0,
    itemToBeDeleted: '',
    loading3: false,
    loading4: false,
    isLoading: false,
    productLoader: false,
    editForm: false,
    showConfirmation: false,
    overlay: false,
    itemsPerPage: 10,
    currentField: 0,
    tableLoader: false,
    buttonLoader: false,
    date: new Date(),
    selectedVendorDetails: {},
    selectedContactDetails: {},
    selectedProductInfo: [],
    formFields: {
      vendorName: '',
      contactName: '',
      firstName: '',
      lastName: '',
      phone: '',
      secondPhone: '',
      email: '',
      secondaryEmail: '',
      vendorSource: '',
      vendorStatus: '',
      vendorType: '',
      serviceType: '',
      description: '',
      serviceHours: '',
      quantity: '',
      quantityStops: '',
      startTime: '',
      endTime: '',
      standingGuardRate: '',
      ratePerStop: '',
      street: '',
      state: '',
      city: '',
      zipcode: '',
      leadsDate: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      submissionDate: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      date: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      productsList: [],
    },
    inputs: [
      {
        leadsDate: '',
        callDate: '',
        callbackDate:'',
        notes: '',
        standingGuardRate: '',
        ratePerStop: '',
        serviceType: '',
        description: '',
        serviceHours: '',
        quantity: '',
        quantityStops: '',
        startTime: '',
        endTime: '',
      },
    ],
    formFields2: {
      vendorName: '',
      firstName: '',
      lastName: '',
      phone: '',
      email: '',
      vendorSource: '',
      vendorStatus: '',
      vendorType: '',
      street: '',
      state: '',
      city: '',
      zipcode: '',
    },
    modal_date_picker: false,
    form_valid: true,
    headers: [
      {
        text: 'Sales Date',
        value: 'leadsDate',
        align: 'center',
        sortable: true,
        divider: true,
      },
      {
        text: 'Company',
        value: 'company',
        align: 'center',
        sortable: true,
        divider: true,
      },
      {
        text: 'Phone',
        value: 'phone',
        align: 'center',
        sortable: true,
        divider: true,
      },
      {
        text: 'Email',
        value: 'email',
        align: 'center',
        sortable: true,
        divider: true,
      },
      {
        text: 'Sales Agent',
        value: 'leadOwner',
        align: 'center',
        sortable: true,
        divider: true,
      },
      {
        text: 'Sales Manager',
        value: 'salesAgent',
        align: 'center',
        sortable: true,
        divider: true,
      },
      {
        text: 'Lead Status',
        value: 'leadStatus',
        align: 'center',
        sortable: true,
        divider: true,
      },
      {
        text: '',
        value: 'controls',
        align: 'center',
        sortable: true,
        divider: true,
      },
    ],
  };
},
mounted() {
  this.getDashboard();
  this.getPurchaseOrdersList();
  Event.$on('openForm', () => {
    // Event.$off();
    console.log('Starting form in ' + this.$route.path);
    if (this.$route.path !== '/sales') {
      return;
    }
    this.readOutLoud('Please fill the following details');
    setTimeout(() => {
      this.readOutLoud('Vendor Name');
      this.startListining();
    }, 3000);
    this.overlay = true;
  });
  Event.$on('editFromRecord', (data) => {
    if (this.$route.path !== '/sales') {
      return;
    }
    console.log(data.msg);
    this.editPurchaseOrder(this.purchaseordersList[0]);
  });
  Event.$on('searchFromRecord', (data) => {
    if (this.$route.path !== '/sales') {
      return;
    }
    this.search = data.msg;
    this.SearchSalesLead(data.msg);
  });
  Event.$on('generatePurchaseOrder', (msg) => {
    if (this.$route.path !== '/sales') {
      return;
    }
    console.log(msg);
    if (this.overlay) {
      this.createInvoice();
    }
  });
  Event.$on('formDetails', (data) => {
    console.log(data);
    switch (data.msg) {
      case 'next':
        this.currentField++;
        this.navigateField();
        break;
      case 'previous':
        this.currentField--;
        this.navigateField();
        break;
      case 'submit':
        this.readOutLoud('Please verify your details');
        break;
      case 'verified':
        this.overlay = false;
        this.submitForm();
        this.submitForm3();
        this.submitForm4();
        break;
      default:
        this.fillForm(data.msg);
        break;
    }
  });
  const invoiceOwners = [];
  const ownerData = {
    "Owner 1": {
      header: "Header 1",
      content: "Content 1",
      grandTotal: "",
      totalQuantity: "",
      totalInvoices: "",
      goal: "",
    },
    "Owner 2": {
      header: "Header 2",
      content: "Content 2",
      grandTotal: "",
      totalQuantity: "",
      totalInvoices: "",
      goal: "",
    },
    "Owner 3": {
      header: "Header 3",
      content: "Content 3",
      grandTotal: "",
      totalQuantity: "",
      totalInvoices: "",
      goal: "",
    },
  };
  this.generateScoreboardReport();
  this.invoiceOwners = invoiceOwners;
  this.ownerData = ownerData;
this.originalData = [...this.invoicesList];
},
printInvoice: function() {
  window.print();
},
watch: {
  reportType: {
handler() {
  this.fetchData();
},
immediate: true
},
selectedInvoices: {
  handler() {
    this.renderReport();
  },
  deep: true,
},
  searchVendorName(val) {
    // Items have already been loaded
    if (!val) return;
    // if (this.vendor_list.length > 0) return;
    this.isLoading = true;
    fetch(`${process.env.VUE_APP_NODE_SERVER}vendor-form/search`, {
      method: 'POST',
      body: JSON.stringify({ searchText: val }), // string or object
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    })
      .then((res) => res.clone().json())
      .then((res) => {
        this.vendor_list = res.result;
        this.isLoading = false;
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => (this.isLoading = false));
  },
  searchContactName(val) {
    // Items have already been loaded
    // if(!val) return
    // if (this.contact_list.length > 0) return;
    this.isLoading = true;
    fetch(`${process.env.VUE_APP_NODE_SERVER}contact-form/search`, {
      method: 'POST',
      body: JSON.stringify({ searchText: val }), // string or object
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    })
      .then((res) => res.clone().json())
      .then((res) => {
        this.contact_list = res.result;
        this.isLoading = false;
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => (this.isLoading = false));
  },
  selectedVendorDetails(val) {
    if (!val) return;
    this.formFields.street = val.street ? val.street : '';
    this.formFields.city = val.city ? val.city : '';
    this.formFields.state = val.state ? val.state : '';
    this.formFields.zipcode = val.zipcode ? val.zipcode : '';
    this.formFields.vendorType = val.vendorType ? val.vendorType : '';
    this.formFields.vendorSource = val.vendorSource ? val.vendorSource : '';
    this.formFields.vendorStatus = val.vendorStatus ? val.vendorStatus : '';
    this.formFields.firstName = val.firstName ? val.firstName : '';
    this.formFields.lastName = val.lastName ? val.lastName : '';
    this.formFields.email = val.email ? val.email : '';
    this.formFields.phone = val.phone ? val.phone : '';
    this.contact_list.push(this.formFields);
    this.vendor_list.push(this.formFields);
  },
},
methods: {
  triggerConfettiAnimation() {
  // Trigger the confetti animation
  this.$refs.confetti.start();
},
 sendEmail() {
  emailjs.sendForm('service_7tk19m9', 'ig_welcome', this.$refs.form, 'user_odKCu76HuvCXramvgkSwn')
      .then((result) => {
          console.log('SUCCESS!', result.text);
      }, (error) => {
          console.log('FAILED...', error.text);
      });
  },
  toggleOrder() {
    this.sortDesc = !this.sortDesc;
  },
  nextSort() {
    let index = this.headers.findIndex((h) => h.value === this.sortBy);
    index = (index + 1) % this.headers.length;
    this.sortBy = this.headers[index].value;
  },
  initialize() {
    this.purchaseordersList = [];
  },
  getDashboard: async function() {
    const rawResponse = await fetch(
      `${process.env.VUE_APP_NODE_SERVER}analytics/all`
    );
    const content = await rawResponse.json();
    this.dashboard.purchaseorders = content.response.purchaseorders;
    this.dashboard.products = content.response.products;
    console.log(this.dashboard);
    this.dashboard = content.response;
    console.log(content);
  },
  add() {
    this.inputs.push({
        callDate: '',
        callbackDate: '',
        notes: '',
    });
    console.log(this.inputs);
    this.productsList = [];
  },
  remove(index) {
    this.inputs.splice(index, 1);
    this.productsList = [];
  },
  onScroll() {
    this.scrollInvoked++;
  },
  selectProduct(product, i) {
    console.log(product);
    this.inputs[i].callDate;
    this.inputs[i].callbackDate;
    this.inputs[i].notes;
    this.productsList = [];
    product.status = 'Available';
    this.selectedProductInfo.push(product);
    this.type = '';
  },
  searchProducts(event, index, type) {
    if (!event.target.value) return;
    this.productLoader = true;
    this.optionIndex = index;
    this.type = type;
    fetch(
      `${process.env.VUE_APP_NODE_SERVER}purchaseorder-form/phone-check`,
      {
        method: 'POST',
        body: JSON.stringify({ searchText: event.target.value }), // string or object
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      }
    )
      .then((res) => res.clone().json())
      .then((res) => {
        this.productsList.push(res.data);
        this.productLoader = false;
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => (this.productLoader = false));
    // } else {
    //   setTimeout(() => {
    //     fetch(
    //       `${process.env.VUE_APP_NODE_SERVER}product-master/iemi-search`,
    //       {
    //         method: 'POST',
    //         body: JSON.stringify({ searchText: event.target.value }), // string or object
    //         headers: {
    //           Accept: 'application/json',
    //           'Content-Type': 'application/json',
    //         },
    //       }
    //     )
    //       .then((res) => res.clone().json())
    //       .then((res) => {
    //         this.productsList = res.result;
    //         this.productLoader = false;
    //       })
    //       .catch((err) => {
    //         console.log(err);
    //       })
    //       .finally(() => (this.productLoader = false));
    //   }, 1000);
    // }
  },
  handleSubTotal() {
    if (this.inputs.length) {
      this.formFields.subtotal = this.inputs.reduce(
        (accum, item) => accum + +item.amount,
        0
      );
    }
    let tax = this.formFields.tax ? this.formFields.tax : 1;
    this.formFields.total =
      this.formFields.subtotal * tax / 100 +
      this.formFields.subtotal -
      this.formFields.discount;
  },
  handleTotal() {
    let tax = this.formFields.tax ? this.formFields.tax : 1;
    this.formFields.total =
      this.formFields.subtotal * tax / 100 +
      this.formFields.subtotal -
      this.formFields.discount;
  },

  SearchSalesLead: async function() {
    console.log(this.search);
    if (!this.search) this.getPurchaseOrdersList();
    this.isLoading = true;
    const response = await fetch(
      `${process.env.VUE_APP_NODE_SERVER}sales-form/search`,
      {
        method: 'POST',
        body: JSON.stringify({ searchText: this.search }), // string or object
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      }
    );
    const json = await response.json();
this.$emit('update-sales-date', json.leadsDate);
    this.isLoading = false;
    console.log(json);
    this.purchaseordersList = json.result;

    let filteredData = this.originalData.filter((item) => {
    let dateCondition = true;
    if (this.startDate && this.endDate) {
      const itemDate = new Date(item.date);
      const startDate = new Date(this.startDate);
      const endDate = new Date(this.endDate);
      dateCondition = itemDate >= startDate && itemDate <= endDate;
    }

    let queryCondition = true;
    if (this.query) {
      queryCondition = item.name.toLowerCase().includes(this.query.toLowerCase());
    }

    return dateCondition && queryCondition;
  });

  this.invoicesList = filteredData;
  this.$emit('searchInvoice', this.invoicesList);
},
callFirstPhone: async function() {
  try {
    const response = await fetch(
      `${process.env.VUE_APP_NODE_SERVER}/call-form/makeCall`, 
      {
        method: 'POST',
        body: JSON.stringify({ phone: this.formFields.phone }),
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
      }
    );
    const json = await response.json();
    console.log(json); // Log the response from server
  } catch (error) {
    console.error('Error:', error);
  }
},

callSecondPhone: async function() {
  try {
    const response = await fetch(
      `${process.env.VUE_APP_NODE_SERVER}/call-form/makeCall`,
      {
        method: 'POST',
        body: JSON.stringify({ phone: this.formFields.secondPhone }),
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
      }
    );
    const json = await response.json();
    console.log(json); // Log the response from server
  } catch (error) {
    console.error('Error:', error);
  }
},
generateReport() {
  let csvContent;
if (this.reportType === 'Sales Report') {
  csvContent = this.generateSalesReport();
} else if (this.reportType === 'Profit Margins Report') {
  csvContent = this.generateProfitMarginsReport();
} else if (this.reportType === 'Invoice Owner Report') {
  csvContent = this.generateInvoiceOwnerReport();
} else if (this.reportType === 'Invoice Owner Scoreboard Report') {
  csvContent = this.generateInvoiceOwnerScoreboardReport();
} else if (this.reportType === 'Scoreboard Report') {
  csvContent = this.generateScoreboardReport();
}

let csvRows = csvContent.split("\n");
let htmlRows = csvRows.map(row => {
let columns = row.split(",");
return `<tr>${columns.map(column => `<td>${column}</td>`).join('')}</tr>`;
}).join('');

let htmlContent = `
<html>
<head>
<style>
body{
background: -webkit-linear-gradient(left, #29343a, #2d4552);
background: linear-gradient(to right, #29343a, #2d4552);
font-family: 'Roboto', sans-serif;
}
    table {
        border-collapse: collapse;
        margin: 20px auto;
        background-color: rgba(255, 255, 255, 0.1);
    }

    h1{
font-size: 30px;
color: #fff;
text-transform: uppercase;
font-weight: 300;
text-align: center;
margin-bottom: 15px;
}
table{
width:100%;
table-layout: fixed;
}
.tbl-header{
margin-top: 50px;
background-color: rgba(255,255,255,0.3);
}
.tbl-content{
height:300px;
overflow-x:auto;
margin-top: 0px;
border: 1px solid rgba(255,255,255,0.3);
}
th{
padding: 20px 15px;
text-align: left;
font-weight: 500;
font-size: 12px;
color: #fff;
text-transform: uppercase;
}
td{
padding: 15px;
text-align: left;
vertical-align:middle;
font-weight: 300;
font-size: 12px;
color: #fff;
border-bottom: solid 1px rgba(255,255,255,0.1);
}

</style>
</head>
<body>
<h1>${this.reportType}</h1>
<table>
    ${htmlRows}
</table>
</body>
</html>`;


let blob = new Blob([htmlContent], { type: "text/html" });
let url = URL.createObjectURL(blob);

this.$refs.outputIframe.src = url;
this.reportGenerated = true;
const outputIframe = document.querySelector(".data-table-iframe");

// Replace this with your actual condition
const shouldShowDataTable = true;

if (shouldShowDataTable) {
outputIframe.classList.add("show-data-table");
} else {
outputIframe.classList.remove("show-data-table");
}

},
generateInvoiceOwnerScoreboardReport(goal = 3) {
let invoiceOwners = [...new Set(this.invoicesList.map(invoice => invoice.invoiceOwner))];
let ownerData = {};

invoiceOwners.forEach((invoiceOwner) => {
  ownerData[invoiceOwner] = {
    header: ["InvoiceOwner", ...this.headers.map((header) => header.text)].join(","),
    content: "",
    grandTotal: 0,
    totalQuantity: 0,
    totalInvoices: 0,
    totalGoal: 0,
  };
});

let filteredInvoices = this.invoicesList.filter((invoice) => {
  let dateCondition = true;
  if (this.startDate && this.endDate) {
    const invoiceDate = new Date(invoice.invoiceDate);
    const startDate = new Date(this.startDate);
    const endDate = new Date(this.endDate);
    dateCondition = invoiceDate >= startDate && invoiceDate <= endDate;
  }
  return dateCondition;
});

filteredInvoices.forEach((invoice) => {
  let invoiceOwner = invoice.invoiceOwner;
  let rowData = [invoiceOwner, ...this.headers.map((header) => invoice[header.value])].join(",");
  if (Object.prototype.hasOwnProperty.call(ownerData, invoiceOwner)) {
    ownerData[invoiceOwner].content += rowData + "\r\n";
    ownerData[invoiceOwner].grandTotal += invoice.total;
    ownerData[invoiceOwner].totalQuantity += invoice.quantity;
    ownerData[invoiceOwner].totalInvoices++;
    ownerData[invoiceOwner].totalGoal += invoice.total >= goal ? 1 : 0;
    ownerData[invoiceOwner].goalCompleted = ownerData[invoiceOwner].totalInvoices >= goal ? "✅" : "❌";
  } 
});

let csvContent = "data:text/csv;charset=utf-8,";
invoiceOwners.sort((a, b) => ownerData[b].totalInvoices - ownerData[a].totalInvoices);
invoiceOwners.forEach((owner) => {
  csvContent += `InvoiceOwner: ${owner}\r\n`;
  csvContent += ownerData[owner].header + "\r\n";
  csvContent += ownerData[owner].content;
  csvContent += "Grand Total," + ownerData[owner].grandTotal + "\r\n";
  csvContent += "Total Quantity," + ownerData[owner].totalQuantity + "\r\n";
  csvContent += "Total Invoices," + ownerData[owner].totalInvoices + "\r\n";
  csvContent += "Goal Completion," + (ownerData[owner].totalInvoices >= goal ? "✅" : "❌") + "\r\n";
  csvContent += "\r\n";
});
this.createChart(invoiceOwners, invoiceOwners.map(owner => ownerData[owner].totalInvoices), 'invoiceOwnerScoreboardChart');
return csvContent;
},
generateScoreboardReport(goal = 3) {
let invoiceOwners = [...new Set(this.invoicesList.map(invoice => invoice.invoiceOwner))];
let ownerData = {};

invoiceOwners.forEach((invoiceOwner) => {
  ownerData[invoiceOwner] = {
    header: ["InvoiceOwner", ...this.headers.map((header) => header.text)].join(","),
    content: "",
    grandTotal: 0,
    totalQuantity: 0,
    totalInvoices: 0,
    totalGoal: 0,
  };
});

let filteredInvoices = this.invoicesList.filter((invoice) => {
  let dateCondition = true;
  if (this.startDate && this.endDate) {
    const invoiceDate = new Date(invoice.invoiceDate);
    const startDate = new Date(this.startDate);
    const endDate = new Date(this.endDate);
    dateCondition = invoiceDate >= startDate && invoiceDate <= endDate;
  }
  return dateCondition;
});

filteredInvoices.forEach((invoice) => {
  let invoiceOwner = invoice.invoiceOwner;
  let rowData = [invoiceOwner, ...this.headers.map((header) => invoice[header.value])].join(",");
  if (Object.prototype.hasOwnProperty.call(ownerData, invoiceOwner)) {
    ownerData[invoiceOwner].content += rowData + "\r\n";
    ownerData[invoiceOwner].grandTotal += invoice.total;
    ownerData[invoiceOwner].totalQuantity += invoice.quantity;
    ownerData[invoiceOwner].totalInvoices++;
    ownerData[invoiceOwner].totalGoal += invoice.total >= goal ? 1 : 0;
    // ownerData[invoiceOwner].goalCompleted = ownerData[invoiceOwner].totalInvoices >= goal ? this.goalAchieved : this.goalFailed;
    ownerData[invoiceOwner].goalCompleted = ownerData[invoiceOwner].totalInvoices == 0 ? this.dataZero : (ownerData[invoiceOwner].totalInvoices >= goal ? this.goalAchieved : this.goalFailed);
  }
});

let csvContent = "data:text/csv;charset=utf-8,";
invoiceOwners.sort((a, b) => ownerData[b].totalInvoices - ownerData[a].totalInvoices);
invoiceOwners.forEach((owner) => {
  csvContent += `InvoiceOwner: ${owner}\r\n`;
  csvContent += ownerData[owner].header + "\r\n";
  csvContent += ownerData[owner].content;
  csvContent += "Grand Total," + ownerData[owner].grandTotal + "\r\n";
  csvContent += "Total Quantity," + ownerData[owner].totalQuantity + "\r\n";
  csvContent += "Total Invoices," + ownerData[owner].totalInvoices + "\r\n";
  csvContent += "Goal Completion," + (ownerData[owner].totalInvoices >= goal ? "✅" : "❌") + "\r\n";
  csvContent += "\r\n";
});

// Replace the invoiceOwners and ownerData assignments from Code 1 with the updated values
this.invoiceOwners = Object.keys(ownerData);
this.ownerData = ownerData;
this.originalData = [...this.invoicesList];

this.createChart(this.invoiceOwners, this.invoiceOwners.map(owner => ownerData[owner].totalInvoices), 'invoiceOwnerScoreboardChart');

const renderScoreboard = () => {
  // Your existing code for generating the scoreboard report

  // Update the HTML table
  const tableBody = document.getElementById("scoreboardTableBody");
  tableBody.innerHTML = ""; // Clear existing table rows

  invoiceOwners.forEach((owner) => {
    const row = document.createElement("tr");

    const ownerCell = document.createElement("td");
    ownerCell.textContent = owner;
    row.appendChild(ownerCell);

    const totalQuantityCell = document.createElement("td");
    totalQuantityCell.textContent = ownerData[owner].totalQuantity;
    row.appendChild(totalQuantityCell);

    const totalInvoicesCell = document.createElement("td");
    totalInvoicesCell.textContent = ownerData[owner].totalInvoices;
    row.appendChild(totalInvoicesCell);

    const goalCell = document.createElement("td");
    goalCell.textContent = ownerData[owner].totalGoal;
    row.appendChild(goalCell);

    tableBody.appendChild(row);
  });
};

// Register the renderScoreboard function to execute on window.onload
window.onload = renderScoreboard;
return csvContent;
},

// generateScoreboardReport(goal = 3) {
//   let invoiceOwners = [...new Set(this.invoicesList.map(invoice => invoice.invoiceOwner))];
//   let ownerData = {};

//   invoiceOwners.forEach((invoiceOwner) => {
//     ownerData[invoiceOwner] = {
//       header: ["InvoiceOwner", ...this.headers.map((header) => header.text)].join(","),
//       content: "",
//       grandTotal: 0,
//       totalQuantity: 0,
//       totalInvoices: 0,
//       totalGoal: 0,
//     };
//   });

//   let today = new Date();
// today.setHours(0,0,0,0); // to ensure it matches from the start of the day
// let filteredInvoices = this.invoicesList.filter((invoice) => {
//   const invoiceDate = new Date(invoice.invoiceDate);
//   const startDate = this.startDate ? new Date(this.startDate) : new Date(today);
//   const endDate = this.endDate ? new Date(this.endDate) : new Date(today);
//   endDate.setHours(23,59,59,999); // to ensure it matches until the end of the day
//   return invoiceDate >= startDate && invoiceDate <= endDate;
// });


//   filteredInvoices.forEach((invoice) => {
//     let invoiceOwner = invoice.invoiceOwner;
//     let rowData = [invoiceOwner, ...this.headers.map((header) => invoice[header.value])].join(",");
//     if (Object.prototype.hasOwnProperty.call(ownerData, invoiceOwner)) {
//       ownerData[invoiceOwner].content += rowData + "\r\n";
//       ownerData[invoiceOwner].grandTotal += invoice.total;
//       ownerData[invoiceOwner].totalQuantity += invoice.quantity;
//       ownerData[invoiceOwner].totalInvoices++;
//       ownerData[invoiceOwner].totalGoal += invoice.total >= goal ? 1 : 0;
//     }
//   });

//   let csvContent = "data:text/csv;charset=utf-8,";
//   invoiceOwners.sort((a, b) => ownerData[b].totalInvoices - ownerData[a].totalInvoices);
//   invoiceOwners.forEach((owner) => {
//     csvContent += `InvoiceOwner: ${owner}\r\n`;
//     csvContent += ownerData[owner].header + "\r\n";
//     csvContent += ownerData[owner].content;
//     csvContent += "Grand Total," + ownerData[owner].grandTotal + "\r\n";
//     csvContent += "Total Quantity," + ownerData[owner].totalQuantity + "\r\n";
//     csvContent += "Total Invoices," + ownerData[owner].totalInvoices + "\r\n";
//     csvContent += "Goal Completion," + (ownerData[owner].totalInvoices >= goal ? "✅" : "❌") + "\r\n";
//     csvContent += "\r\n";
//   });

//   this.invoiceOwners = Object.keys(ownerData);
//   this.ownerData = ownerData;
//   this.originalData = [...this.invoicesList];

//   this.createChart(this.invoiceOwners, this.invoiceOwners.map(owner => ownerData[owner].totalInvoices), 'invoiceOwnerScoreboardChart');

//   const renderScoreboard = () => {
//     // Update the HTML table
//     const tableBody = document.getElementById("scoreboardTableBody");
//     tableBody.innerHTML = ""; // Clear existing table rows

//     this.invoiceOwners.forEach((owner) => {
//       const row = document.createElement("tr");

//       const ownerCell = document.createElement("td");
//       ownerCell.textContent = owner;
//       row.appendChild(ownerCell);

//       const totalQuantityCell = document.createElement("td");
//       totalQuantityCell.textContent = this.ownerData[owner].totalQuantity;
//       row.appendChild(totalQuantityCell);

//       const totalInvoicesCell = document.createElement("td");
//       totalInvoicesCell.textContent = this.ownerData[owner].totalInvoices;
//       row.appendChild(totalInvoicesCell);

//       const goalCell = document.createElement("td");
//       goalCell.textContent = this.ownerData[owner].totalGoal;
//       row.appendChild(goalCell);

//       tableBody.appendChild(row);
//     });
//   };

//   // Register the renderScoreboard function to execute on window.onload
//   window.onload = renderScoreboard;

//   return csvContent;
// },

generateInvoiceOwnerReport() {
let invoiceOwners = [...new Set(this.invoicesList.map(invoice => invoice.invoiceOwner))];
let ownerData = {};

invoiceOwners.forEach((invoiceOwner) => {
ownerData[invoiceOwner] = {
  header: ["InvoiceOwner", ...this.headers.map((header) => header.text)].join(","),
  content: "",
  grandTotal: 0,
  totalQuantity: 0,
  totalInvoices: 0
};
});

let filteredInvoices = this.invoicesList.filter((invoice) => {
let dateCondition = true;
if (this.startDate && this.endDate) {
  const invoiceDate = new Date(invoice.invoiceDate);
  const startDate = new Date(this.startDate);
  const endDate = new Date(this.endDate);
  dateCondition = invoiceDate >= startDate && invoiceDate <= endDate;
}
return dateCondition;
});

filteredInvoices.forEach((invoice) => {
let invoiceOwner = invoice.invoiceOwner;
let rowData = [invoiceOwner, ...this.headers.map((header) => invoice[header.value])].join(",");
if (Object.prototype.hasOwnProperty.call(ownerData, invoiceOwner)) {
  ownerData[invoiceOwner].content += rowData + "\r\n";
  ownerData[invoiceOwner].grandTotal += invoice.total;
  ownerData[invoiceOwner].totalQuantity += invoice.quantity;
  ownerData[invoiceOwner].totalInvoices++;
}
});

let csvContent = "data:text/csv;charset=utf-8,";
invoiceOwners.forEach((owner) => {
csvContent += `InvoiceOwner: ${owner}\r\n`;
csvContent += ownerData[owner].header + "\r\n";
csvContent += ownerData[owner].content;
csvContent += "Grand Total," + ownerData[owner].grandTotal + "\r\n";
csvContent += "Total Quantity," + ownerData[owner].totalQuantity + "\r\n";
csvContent += "Total Invoices," + ownerData[owner].totalInvoices + "\r\n";
csvContent += "\r\n";
});
this.createChart(invoiceOwners, invoiceOwners.map(owner => ownerData[owner].grandTotal), 'invoiceOwnerChart');
return csvContent;
},

generateSalesReport() {
let accountTypes = ["Business", "Personal", "Non-Profit"];
let accountData = {};

accountTypes.forEach((type) => {
accountData[type] = {
  header: this.headers.map((header) => header.text).join(","),
  content: "",
  grandTotal: 0,
  totalQuantity: 0,
};
});

let filteredInvoices = this.invoicesList.filter((invoice) => {
let dateCondition = true;
if (this.startDate && this.endDate) {
  const invoiceDate = new Date(invoice.invoiceDate);
  const startDate = new Date(this.startDate);
  const endDate = new Date(this.endDate);
  dateCondition = invoiceDate >= startDate && invoiceDate <= endDate;
}
return dateCondition;
});

filteredInvoices.forEach((row) => {
let rowData = this.headers.map((header) => row[header.value]).join(",");
let accountType = row.accountType;
if (Object.prototype.hasOwnProperty.call(accountData, accountType)) {
  accountData[accountType].content += rowData + "\r\n";
  accountData[accountType].grandTotal += row.total;
  accountData[accountType].totalQuantity += row.quantity;
}
});

let csvContent = "data:text/csv;charset=utf-8,";
accountTypes.forEach((type) => {
csvContent += `Account Type: ${type}\r\n`;
csvContent += accountData[type].header + "\r\n";
csvContent += accountData[type].content;
csvContent += "Grand Total," + accountData[type].grandTotal + "\r\n";
csvContent += "Total Quantity," + accountData[type].totalQuantity + "\r\n";
csvContent += "\r\n";
});
this.createChart(accountTypes, accountTypes.map(type => accountData[type].grandTotal), 'salesChart');
return csvContent;

},

generateProfitMarginsReport() {
let accountData = {
productsList: {
  header: this.headers.map((header) => header.text)
    .concat(["Offer", "Selling Price", "Profit", "Margin Percentage"])
    .join(","),
  content: "",
  grandTotal: 0,
  totalQuantity: 0,
  totalOffer: 0,
  totalProfit: 0,
},
};

// Find the matching product data from the searchProducts results
const findMatchingProduct = (imei) => {
return this.productsList.find((product) => product.IMEI === imei);
};

let filteredInvoices = this.invoicesList.filter((invoice) => {
let dateCondition = true;
if (this.startDate && this.endDate) {
  const invoiceDate = new Date(invoice.invoiceDate);
  const startDate = new Date(this.startDate);
  const endDate = new Date(this.endDate);
  dateCondition = invoiceDate >= startDate && invoiceDate <= endDate;
}
return dateCondition;
});

filteredInvoices.forEach((row) => {
let product = findMatchingProduct(row.IMEI);
let offer = 0;
let profit = 0;
let marginPercentage = 0;
let sellingPrice = 0;

if (product) {
  offer = product.offer;
  sellingPrice = product.price ? product.price : row.formFiles.amount; // Update Selling Price if available
  profit = sellingPrice - offer;
  marginPercentage = (profit / sellingPrice) * 100;
}

let rowData = this.headers
  .map((header) => row[header.value])
  .concat([offer, sellingPrice, profit, marginPercentage.toFixed(2) + "%"])
  .join(",");

accountData.productsList.content += rowData + "\r\n";
accountData.productsList.grandTotal += sellingPrice;
accountData.productsList.totalQuantity += row.quantity;
accountData.productsList.totalOffer += offer;
accountData.productsList.totalProfit += profit;
});

let csvContent = "data:text/csv;charset=utf-8,";
csvContent += accountData.productsList.header + "\r\n";
csvContent += accountData.productsList.content;
csvContent += "Total Offer," + accountData.productsList.totalOffer + "\r\n";
csvContent += "Grand Total," + accountData.productsList.grandTotal + "\r\n";
csvContent += "Total Profit," + accountData.productsList.totalProfit + "\r\n";
csvContent += "Total Quantity," + accountData.productsList.totalQuantity + "\r\n";
this.createChart(['Products'], [accountData.productsList.grandTotal], 'profitMarginsChart');

return csvContent;
},

downloadReport() {
  let filteredInvoices = this.invoicesList.filter((invoice) => {
    let dateCondition = true;
    if (this.startDate && this.endDate) {
      const invoiceDate = new Date(invoice.invoiceDate);
      const startDate = new Date(this.startDate);
      const endDate = new Date(this.endDate);
      dateCondition = invoiceDate >= startDate && invoiceDate <= endDate;
    }
    return dateCondition;
  });

  let csvContent = "data:text/csv;charset=utf-8,";
  let header = this.headers.map((header) => header.text).join(",");
  csvContent += header + "\r\n";

  filteredInvoices.forEach((row) => {
    let rowData = this.headers.map((header) => row[header.value]).join(",");
    csvContent += rowData + "\r\n";
  });

  let encodedUri = encodeURI(csvContent);
  let link = document.createElement("a");
  link.setAttribute("href", encodedUri);
  link.setAttribute("download", "general_report.csv");
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  if (this.reportType === 'Sales Report') {
    this.downloadSalesReport(filteredInvoices);
  } else if (this.reportType === 'Profit Margins Report') {
    this.downloadProfitMarginsReport(filteredInvoices);
  } else if (this.reportType === 'Invoice Owner Report') {
    this.downloadInvoiceOwnerReport(filteredInvoices);
  } else if (this.reportType === 'Invoice Owner Scoreboard Report') {
    this.downloadInvoiceOwnerScoreboardReport();
  }
},
downloadInvoiceOwnerScoreboardReport(goal = 3) {
  let invoiceOwners = [...new Set(this.invoicesList.map(invoice => invoice.invoiceOwner))];
  let ownerData = {};

  invoiceOwners.forEach((invoiceOwner) => {
      ownerData[invoiceOwner] = {
          header: ["InvoiceOwner", ...this.headers.map((header) => header.text)].join(","),
          content: "",
          grandTotal: 0,
          totalQuantity: 0,
          totalInvoices: 0,
          goalCompleted: false
      };
  });

  let filteredInvoices = this.invoicesList.filter((invoice) => {
      let dateCondition = true;
      if (this.startDate && this.endDate) {
          const invoiceDate = new Date(invoice.invoiceDate);
          const startDate = new Date(this.startDate);
          const endDate = new Date(this.endDate);
          dateCondition = invoiceDate >= startDate && invoiceDate <= endDate;
      }
      return dateCondition;
  });

  filteredInvoices.forEach((invoice) => {
      let invoiceOwner = invoice.invoiceOwner;
      let rowData = [invoiceOwner, ...this.headers.map((header) => invoice[header.value])].join(",");
      if (Object.prototype.hasOwnProperty.call(ownerData, invoiceOwner)) {
          ownerData[invoiceOwner].content += rowData + "\r\n";
          ownerData[invoiceOwner].grandTotal += invoice.total;
          ownerData[invoiceOwner].totalQuantity += invoice.quantity;
          ownerData[invoiceOwner].totalInvoices++;

          if (ownerData[invoiceOwner].totalInvoices >= goal) {
              ownerData[invoiceOwner].goalCompleted = true;
          }
      }
  });

  // Sort by highest totalInvoices
  invoiceOwners.sort((a, b) => ownerData[b].totalInvoices - ownerData[a].totalInvoices);

  let csvContent = "data:text/csv;charset=utf-8,";
  invoiceOwners.forEach((owner) => {
      csvContent += `InvoiceOwner: ${owner}${ownerData[owner].goalCompleted ? ' 🎯' : ''}\r\n`;
      csvContent += ownerData[owner].header + "\r\n";
      csvContent += ownerData[owner].content;
      csvContent += "Grand Total," + ownerData[owner].grandTotal + "\r\n";
      csvContent += "Total Quantity," + ownerData[owner].totalQuantity + "\r\n";
      csvContent += "Total Invoices," + ownerData[owner].totalInvoices + "\r\n";
      csvContent += "\r\n";
  });

  let encodedUri = encodeURI(csvContent);
  let link = document.createElement("a");
  link.setAttribute("href", encodedUri);
  link.setAttribute("download", "InvoiceOwner_scoreboard_report.csv");
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  return csvContent;
},

downloadInvoiceOwnerReport() {
let invoiceOwners = [...new Set(this.invoicesList.map(invoice => invoice.invoiceOwner))];
let ownerData = {};

invoiceOwners.forEach((invoiceOwner) => {
ownerData[invoiceOwner] = {
  header: ["InvoiceOwner", ...this.headers.map((header) => header.text)].join(","),
  content: "",
  grandTotal: 0,
  totalQuantity: 0,
  totalInvoices: 0
};
});

let filteredInvoices = this.invoicesList.filter((invoice) => {
let dateCondition = true;
if (this.startDate && this.endDate) {
  const invoiceDate = new Date(invoice.invoiceDate);
  const startDate = new Date(this.startDate);
  const endDate = new Date(this.endDate);
  dateCondition = invoiceDate >= startDate && invoiceDate <= endDate;
}
return dateCondition;
});

filteredInvoices.forEach((invoice) => {
let invoiceOwner = invoice.invoiceOwner;
let rowData = [invoiceOwner, ...this.headers.map((header) => invoice[header.value])].join(",");
if (Object.prototype.hasOwnProperty.call(ownerData, invoiceOwner)) {
  ownerData[invoiceOwner].content += rowData + "\r\n";
  ownerData[invoiceOwner].grandTotal += invoice.total;
  ownerData[invoiceOwner].totalQuantity += invoice.quantity;
  ownerData[invoiceOwner].totalInvoices++;
}
});

let csvContent = "data:text/csv;charset=utf-8,";
invoiceOwners.forEach((owner) => {
csvContent += `InvoiceOwner: ${owner}\r\n`;
csvContent += ownerData[owner].header + "\r\n";
csvContent += ownerData[owner].content;
csvContent += "Grand Total," + ownerData[owner].grandTotal + "\r\n";
csvContent += "Total Quantity," + ownerData[owner].totalQuantity + "\r\n";
csvContent += "Total Invoices," + ownerData[owner].totalInvoices + "\r\n";
csvContent += "\r\n";
});

let encodedUri = encodeURI(csvContent);
let link = document.createElement("a");
link.setAttribute("href", encodedUri);
link.setAttribute("download", "InvoiceOwner_report.csv");
document.body.appendChild(link);
link.click();
document.body.removeChild(link);
return csvContent;
},
downloadSalesReport(filteredInvoices) {
let accountTypes = ["Business", "Personal", "Non-Profit"];
let accountData = {};

accountTypes.forEach((type) => {
accountData[type] = {
  header: this.headers.map((header) => header.text).join(","),
  content: "",
  grandTotal: 0,
  totalQuantity: 0,
};
});

filteredInvoices.forEach((row) => {
let rowData = this.headers.map((header) => row[header.value]).join(",");
let accountType = row.accountType;
if (Object.prototype.hasOwnProperty.call(accountData, accountType)) {
  accountData[accountType].content += rowData + "\r\n";
  accountData[accountType].grandTotal += row.total;
  accountData[accountType].totalQuantity += row.quantity;
}
});

let csvContent = "data:text/csv;charset=utf-8,";
accountTypes.forEach((type) => {
csvContent += `Account Type: ${type}\r\n`;
csvContent += accountData[type].header + "\r\n";
csvContent += accountData[type].content;
csvContent += "Grand Total," + accountData[type].grandTotal + "\r\n";
csvContent += "Total Quantity," + accountData[type].totalQuantity + "\r\n";
csvContent += "\r\n";
});

let encodedUri = encodeURI(csvContent);
let link = document.createElement("a");
link.setAttribute("href", encodedUri);
link.setAttribute("download", "sales_report.csv");
document.body.appendChild(link);
link.click();
document.body.removeChild(link);
return csvContent;
},
downloadProfitMarginsReport(filteredInvoices) {
let accountData = {
productsList: {
  header: this.headers.map((header) => header.text)
    .concat(["Offer", "Selling Price", "Profit", "Margin Percentage"])
    .join(","),
  content: "",
  grandTotal: 0,
  totalQuantity: 0,
  totalOffer: 0,
  totalProfit: 0,
},
};

// Find the matching product data from the searchProducts results
const findMatchingProduct = (imei) => {
return this.productsList.find((product) => product.IMEI === imei);
};

filteredInvoices.forEach((row) => {
let product = findMatchingProduct(row.IMEI);
let offer = 0;
let profit = 0;
let marginPercentage = 0;
let sellingPrice = 0;

if (product) {
  offer = product.offer;
  sellingPrice = product.price ? product.price : row.formFiles.amount; // Update Selling Price if available
  profit = sellingPrice - offer;
  marginPercentage = (profit / sellingPrice) * 100;
}

let rowData = this.headers
  .map((header) => row[header.value])
  .concat([offer, sellingPrice, profit, marginPercentage.toFixed(2) + "%"])
  .join(",");

accountData.productsList.content += rowData + "\r\n";
accountData.productsList.grandTotal += sellingPrice;
accountData.productsList.totalQuantity += row.quantity;
accountData.productsList.totalOffer += offer;
accountData.productsList.totalProfit += profit;
});

let csvContent = "data:text/csv;charset=utf-8,";
csvContent += accountData.productsList.header + "\r\n";
csvContent += accountData.productsList.content;
csvContent += "Total Offer," + accountData.productsList.totalOffer + "\r\n";
csvContent += "Grand Total," + accountData.productsList.grandTotal + "\r\n";
csvContent += "Total Profit," + accountData.productsList.totalProfit + "\r\n";
csvContent += "Total Quantity," + accountData.productsList.totalQuantity + "\r\n";

let encodedUri = encodeURI(csvContent);
let link = document.createElement("a");
link.setAttribute("href", encodedUri);
link.setAttribute("download", "profit_margins_report.csv");
document.body.appendChild(link);
link.click();
document.body.removeChild(link);
return csvContent;
},
  getPurchaseOrdersList: async function() {
    this.tableLoader = true;
    const response = await fetch(
      `${process.env.VUE_APP_NODE_SERVER}lead-form/all`
    );
    const json = await response.json();
    console.log(json);
    this.purchaseordersList = json.result;
    this.dashboard.vendors = this.purchaseordersList.reduce(
      (acc, o) => ((acc[o.vendorName] = (acc[o.vendorName] || 0) + 1), acc),
      {}
    );
    this.dashboard.vendors = Object.keys(this.dashboard.vendors).length;
    this.tableLoader = false;
  },
  submitForm: async function() {
    console.log(this.formFields);
    console.log(this.inputs[0])
    this.formFields.vendorName = this.selectedVendorDetails.vendorName;
    if (!this.inputs[0].callDate) {
      this.$notify({
        group: 'foo',
        title: 'Important message',
        text: 'Please add products',
      });
      return;
    }
    console.log(this.selectedVendorDetails);
    console.log(this.selectedContactDetails);
    this.formFields.productsList = this.inputs;
    this.formFields.quantity = this.inputs.length;
    this.loading3 = true;
    const response = await fetch(
      `${process.env.VUE_APP_NODE_SERVER}sales-form/create`,
      {
        method: 'POST',
        body: JSON.stringify({ ...this.formFields }), // string or object
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      }
    );
    const json = await response.json(); //extract JSON from the http response
    console.log(json[0]);
    this.updateProductStatus();
    setTimeout(() => {
      this.readOutLoud('Sales Lead Created');
      this.getPurchaseOrdersList();
      this.resetForm();
    }, 800);
  },
//     submitForm: async function() {
//       console.log(this.formFields);
//       this.formFields.vendorName = this.selectedVendorDetails.vendorName;
//       this.formFields.leadsDate = new Date().toISOString();

//   if (!this.inputs[0].callDate) {
//     this.$notify({
//       group: 'foo',
//       title: 'Important message',
//       text: 'Please add products',
//     });
//     return;
//   }
//   console.log(this.selectedVendorDetails);
//   console.log(this.selectedContactDetails);

//   this.formFields.productsList = this.inputs;
//   this.formFields.quantity = this.inputs.length;

//   this.loading3 = true;

//   const response = await fetch(
//     `${process.env.VUE_APP_NODE_SERVER}sales-form/create`,
//     {
//       method: 'POST',
//       body: JSON.stringify({ ...this.formFields }), // string or object
//       headers: {
//         Accept: 'application/json',
//         'Content-Type': 'application/json',
//       },
//     }
//   );

//   const json = await response.json(); //extract JSON from the http response
//   console.log(json[0]);
//   this.updateProductStatus();
//   this.$emit('save-sales-data', { ...this.formFields });
//   // calculate service hours
//   const start = new Date(`01/01/2020 ${this.formFields.startTime}`);
//   const end = new Date(`01/01/2020 ${this.formFields.endTime}`);
//   let serviceHours = (end - start) / (1000 * 60 * 60);

//   // deduct break hours based on state laws
//   const breakHours = this.calculateBreakHours(this.formFields.state, serviceHours);
//   serviceHours -= breakHours;

//   // Update service hours in the data model
//   this.serviceHours = serviceHours;

//   setTimeout(() => {
//     this.readOutLoud('Sales Lead Created');
//     this.getPurchaseOrdersList();
//     this.resetForm();
//   }, 800);
// },

  
  submitForm2: async function() {
    this.isLoading = true;
    setTimeout(() => {
      this.readOutLoud('Successfuly sent Welcome Email');
      this.buttonLoader = true;
      this.showEmailConfirmation = true;
      this.resetForm();
    }, 2000);
  },
  submitForm3: async function() {
    console.log(this.formFields);
    // console.log(this.inputs[0])
this.formFields.leadsDate = new Date().toISOString();

    this.loading4 = true;
    await this.updatePurchaseOrder();
    this.loading4 = false;

    const response = await fetch(
      `${process.env.VUE_APP_NODE_SERVER}lead-form/create`,
      {
        method: 'POST',
        body: JSON.stringify({ ...this.formFields }), // string or object
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      }
    );
    this.$emit('save-sales-data', { ...this.formFields });
    const json = await response.json(); //extract JSON from the http response
    console.log(json[0]);

    setTimeout(() => {
      this.readOutLoud('Lead Created');
      this.getPurchaseOrdersList();
      this.resetForm();
    }, 800);
  },
  submitForm4: async function() {
    console.log(this.formFields);
    // console.log(this.inputs[0])
this.formFields.leadsDate = new Date().toISOString();

    this.loading4 = true;
    await this.updatePurchaseOrder();

    const response = await fetch(
      `${process.env.VUE_APP_NODE_SERVER}opportunity-form/create`,
      {
        method: 'POST',
        body: JSON.stringify({ ...this.formFields }), // string or object
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      }
    );
    this.$emit('save-sales-data', { ...this.formFields });
    const json = await response.json(); //extract JSON from the http response
    console.log(json[0]);
    this.onScroll();
    this.$confetti.start();

    new Audio(startAudio).play();
    // Stop the confetti after 5 seconds
    setTimeout(() => {
      this.$confetti.stop();
    }, 5000);
    setTimeout(() => {
      this.readOutLoud('Congratulations, new Opportunity Created');
      this.getPurchaseOrdersList();
      this.resetForm();
    }, 800);
  },
  updateProductStatus: async function() {
    const response = await fetch(
      `${process.env.VUE_APP_NODE_SERVER}product-master/create`,
      {
        method: 'POST',
        body: JSON.stringify(this.selectedProductInfo), // string or object
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      }
    );
    console.log(response);
  },
  deleteConfirmation: function(item) {
    this.itemToBeDeleted = item;
    this.showConfirmation = true;
  },
  editOpportunity: function(data) {
  this.overlay = true;
  this.editForm = true;
  this.formFields = data;
},

updateOpportunity: async function() {
  this.loading3 = true;

  const response = await fetch(
    `${process.env.VUE_APP_NODE_SERVER}opportunity-form/update`,
    {
      method: 'POST',
      body: JSON.stringify(this.formFields), // string or object
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  );
  const responseData = await response.json(); //extract JSON from the http response
  console.log(responseData[0]);

  if (response.ok) {
    // Successfully updated the lead
    this.message = 'Lead updated successfully';
  } else {
    // An error occurred while updating the lead
    this.message = `Error updating lead: ${responseData.message}`;
    this.messageColor = 'error';
  }

  setTimeout(() => {
    this.getLeadsList();
    this.resetForm();
    this.loading3 = false;
  }, 800);
},

  deleteOpportunity: async function() {
  this.loading3 = true;
  const response = await fetch(
    `${process.env.VUE_APP_NODE_SERVER}opportunity-form/delete`,
    {
      method: 'POST',
      body: JSON.stringify({ id: this.itemToBeDeleted._id }), // string or object
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  );

  const responseData = await response.json();

  if (response.ok) {
    // Successfully deleted the lead
    this.message = 'Opportunity deleted successfully';
  } else {
    // An error occurred while deleting the lead
    this.message = `Error deleting lead: ${responseData.message}`;
    this.messageColor = 'error';
  }

  setTimeout(() => {
    this.loading3 = false;
  }, 1000);
},

  editLead: function(data) {
  this.overlay = true;
  this.editForm = true;
  this.formFields = data;
},

updateLead: async function() {
  this.loading3 = true;

  const response = await fetch(
    `${process.env.VUE_APP_NODE_SERVER}opportunity-form/update`,
    {
      method: 'POST',
      body: JSON.stringify(this.formFields), // string or object
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  );
  const responseData = await response.json(); //extract JSON from the http response
  console.log(responseData[0]);

  if (response.ok) {
    // Successfully updated the lead
    this.message = 'Lead updated successfully';
  } else {
    // An error occurred while updating the lead
    this.message = `Error updating lead: ${responseData.message}`;
    this.messageColor = 'error';
  }

  setTimeout(() => {
    this.getLeadsList();
    this.resetForm();
    this.loading3 = false;
  }, 800);
},

  deleteLead: async function() {
  this.loading3 = true;
  const response = await fetch(
    `${process.env.VUE_APP_NODE_SERVER}lead-form/delete`,
    {
      method: 'POST',
      body: JSON.stringify({ id: this.itemToBeDeleted._id }), // string or object
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  );

  const responseData = await response.json();

  if (response.ok) {
    // Successfully deleted the lead
    this.message = 'Lead deleted successfully';
  } else {
    // An error occurred while deleting the lead
    this.message = `Error deleting lead: ${responseData.message}`;
    this.messageColor = 'error';
  }

  setTimeout(() => {
    this.loading3 = false;
  }, 1000);
},
  deletePurchaseOrder: async function() {
    this.loading3 = true;
    const response = await fetch(
      `${process.env.VUE_APP_NODE_SERVER}sales-form/delete`,
      {
        method: 'POST',
        body: JSON.stringify({ id: this.itemToBeDeleted._id }), // string or object
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      }
    );
    const json = await response.json(); //extract JSON from the http response
    console.log(json[0]);
    this.itemToBeDeleted = '';
    this.showConfirmation = false;
    this.loading3 = false;
    setTimeout(() => {
      this.readOutLoud('1 record deleted');
      this.getPurchaseOrdersList();
    }, 800);
  },
  editPurchaseOrder: function(data) {
    this.overlay = true;
    this.editForm = true;
    this.formFields = data;
    this.inputs = data.productsList;
    this.selectedVendorDetails = this.formFields;
    this.selectedContactDetails = this.formFields;
    console.log(this.formFields.vendorName);
    console.log(this.formFields.contactName);
  },
  updatePurchaseOrder: async function() {
    this.loading3 = true;
    this.formFields.vendorName = this.selectedVendorDetails.vendorName;
    this.formFields.contactName = this.selectedContactDetails.contactName;
    this.formFields.submissionDate = new Date().toISOString();
    const response = await fetch(
      `${process.env.VUE_APP_NODE_SERVER}sales-form/update`,
      {
        method: 'POST',
        body: JSON.stringify(this.formFields), // string or object
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      }
    );
    const json = await response.json(); //extract JSON from the http response
    console.log(json[0]);
    setTimeout(() => {
      this.readOutLoud('1 record updated');
      this.getPurchaseOrdersList();
      this.resetForm();
    }, 800);
  },
  resetForm: function() {
    this.overlay = false;
    this.editForm = false;
    this.loading3 = false;
    this.loading4 = false;
    this.inputs = [
      {
        callDate: '',
        callbackDate:'',
        notes: '',
      },
    ];
    this.formFields = {
      vendorName: '',
      company: '',
      contactName: '',
      firstName: '',
      lastName: '',
      phone: '',
      email: '',
      vendorSource: '',
      vendorStatus: '',
      vendorType: '',
      paymentType: '',
      street: '',
      state: '',
      city: '',
      zipcode: '',
      date: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      productsList: [],
    };
  },
  openForm: function() {
    this.overlay = true;
    this.items = [];
    this.selectedProductInfo = [];
  },
  startListining: function() {
    setTimeout(() => {
      Event.$emit('speakModeOn');
    }, 1250);
  },
  beforeDestroy() {
    Event.$off('speakModeOn');
    Event.$off('openForm');
    Event.$off('searchFromRecord');
    Event.$off('editFromRecord');
  },
  readOutLoud: function(msg) {
    const speech = new SpeechSynthesisUtterance();
    speech.text = msg;
    speech.lang = 'en-GB';
    window.speechSynthesis.speak(speech);
    this.speak = msg;
  },
  fillForm: function(msg) {
    switch (this.currentField) {
      case 0:
        //Owner Name
        var owner = this.leadOwner.filter(
          (obj) => obj.toLowerCase() == msg.toLowerCase()
        )[0];
        if (owner) {
          this.formFields.purchaseorderOwner = owner;
          this.currentField++;
        } else {
          this.readOutLoud('Unable to find from list, please try again');
        }
        break;
      case 1:
        this.formFields.purchaseorderDate = dateCommand(msg);
        this.currentField++;
        break;
      case 2:
        this.formFields.purchaseorderSubject = msg;
        this.currentField++;
        break;
      case 3:
        var vendorType = this.vendorOptions.filter(
          (obj) => obj.toLowerCase() == msg.toLowerCase()
        )[0];
        if (vendorType) {
          this.formFields.vendorType = vendorType;
          this.currentField++;
        } else {
          this.readOutLoud('Unable to find from list, please try again');
        }
        break;
      case 4:
        this.formFields.vendorName = msg;
        this.currentField++;
        break;
      case 5:
        var paymentType = this.paymentType.filter(
          (obj) => obj.toLowerCase() == msg.toLowerCase()
        )[0];
        if (paymentType) {
          this.formFields.paymentType = paymentType;
          this.currentField++;
        } else {
          this.readOutLoud('Unable to find from list, please try again');
        }
        break;
      case 6:
        this.formFields.contactName = msg;
        this.currentField++;
        break;
      case 7:
        var purchaseorderStatus = this.purchaseorderStatus.filter(
          (obj) => obj.toLowerCase() == msg.toLowerCase()
        )[0];
        if (purchaseorderStatus) {
          this.formFields.purchaseorderStatus = purchaseorderStatus;
          this.currentField++;
        } else {
          this.readOutLoud('Unable to find from list, please try again');
        }
        break;
      case 8:
        this.formFields.street = msg;
        this.currentField++;
        break;
      case 9:
        this.formFields.state = msg;
        this.currentField++;
        break;
      case 10:
        this.formFields.city = msg;
        this.currentField++;
        break;
      case 11:
        this.formFields.zipcode = msg;
        this.currentField++;
        break;
      case 12:
        this.input.imei = msg;
        this.currentField++;
        break;
    }
    this.navigateField();
  },
  navigateField: function() {
    console.log(this.currentField);
    switch (this.currentField) {
      case 0:
        this.readOutLoud('Purchase Order Owner?');
        break;
      case 1:
        this.readOutLoud('Purchase Order Date?');
        break;
      case 2:
        this.readOutLoud('Purchase Order Subject?');
        break;
      case 3:
        this.readOutLoud('Vendor Type?');
        break;
      case 4:
        this.readOutLoud('Vendor Name?');
        break;
      case 5:
        this.readOutLoud('Payment Type?');
        break;
      case 6:
        this.readOutLoud('Contact Name?');
        break;
      case 7:
        this.readOutLoud('Purchase Order Status?');
        break;
      case 8:
        this.readOutLoud('Street?');
        break;
      case 9:
        this.readOutLoud('State ?');
        break;
      case 10:
        this.readOutLoud('City ?');
        break;
      case 11:
        this.readOutLoud('Zip code ?');
        break;
      case 12:
        this.readOutLoud('IMEI?');
        break;
    }
    this.startListining();
  },
  async createInvoice() {
    const data = this.getSampleData();
    console.log(data);
    console.log(this.inputs);
    for (let i = 0; i < this.inputs.length; i++) {
      data.products.push({
        quantity: this.inputs[i].quantity,
        description: ' MODEL: ' + this.inputs[i].Make + 
        '   ' + this.inputs[i].Model + 
        '  IMEI:  ' + this.inputs[i].IMEI,
        'tax-rate': this.formFields.tax,
        price: this.inputs[i].amount,
      });
      // data.products[i].quantity = this.inputs[i].quantity
      // data.products[i].description = this.inputs[i].productName
      // data.products[i].Price = this.inputs[i].amount
    }
    const result = await easyinvoice.createInvoice(data);
    easyinvoice.download('myCellFundsPurchaseOrders.pdf', result.pdf);
    this.loading3 = false;
  },
  getSampleData() {
    this.loading3 = true;
    return {
      // "customize": {
      //     "template": "SGVsbG8gd29ybGQh" // Must be base64 encoded html. This example contains 'Hello World!' in base64
      // },
      images: {
        logo:
          'https://www.mycellfunds.com/wp-content/uploads/2020/03/Cell_Funds_Logo.png',
        // background:
        //   'https://public.easyinvoice.cloud/img/watermark-draft.jpg',
      },
      sender: {
        company: 'Cell Funds',
        address: '14429 Ventura Blvd. Ste. 108',
        city: 'Sherman Oaks',
        state: 'CA',
        zip: '91423',
        phone: '1-818-989-3175',
        website: 'www.mycellfunds.com',
        // "custom1": "custom value 1",
        // "custom2": "custom value 2",
        // "custom3": "custom value 3"
      },
      client: {
        company: this.formFields.company,
        address: this.formFields.street,
        zip: this.formFields.city,
        city: this.formFields.zipcode,
        country: 'United States Of America',
        // "custom1": "custom value 1",
        // "custom2": "custom value 2",
        // "custom3": "custom value 3"
      },
      information: {
        number: this.formFields._id,
        date: this.formFields.purchaseorderDate,
      },
      products: [],
      'bottom-notice': 'All devices will be processed and Tested for key functions R2 - Ready for Resale. 30-day warranty on devices that pass testing phase, starting from the date of purchase. This warranty is broken by modifying the hardware or software of any product including physical damage. Phones which are damaged at the time of sale are non refundable.',
      settings: {
        currency: 'USD', // See documentation 'Locales and Currency' for more info. Leave empty for no currency.
        // "locale": "nl-NL", // Defaults to en-US, used for number formatting (see docs)
        // "taxNotation": "gst", // Defaults to vat
        // "margin-top": 25, // Default to 25
        // "margin-right": 25, // Default to 25
        // "margin-left": 25, // Default to 25
        // "margin-bottom": 25, // Default to 25
        // "format": "Letter" // Defaults to A4
      },
      // Used for translating the headers to your preferred language
      // Defaults to English. Below example is translated to Dutch
      translate: {
        invoice: 'Purchase Order',
      },
    };
  },
},
};
</script>



<style scoped>

.formBG {
  background: #142e3ad3;
  padding: 20px;
  border-radius: 20px;
  min-height: 200px;
  -webkit-animation: gradient 25s ease infinite;
  -animation: gradient 25s ease infinite;
}
  @-webkit-keyframes gradient {
    0% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
    }
  }

  @keyframes gradient {
    0% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
    }
    height: 100%;
  }
  
  @media only screen and (max-width: 600px) {
   .formBG {
  background: #0c161bb2;
  padding: 20px;
  min-height: 200px;
  -webkit-animation: gradient 25s ease infinite;
  -animation: gradient 25s ease infinite;
}
  @-webkit-keyframes gradient {
    0% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
    }
  }

  @keyframes gradient {
    0% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
    }
    height: 100%;
  } 
}

.user-speach {
position: absolute;
font-size: 12px;
min-width: 0%;
max-width: 120%;
bottom: 15px;
height: 75px;
float: inherit;
left: 0.5%;
border-radius: 20px;
padding: 10px;
color: #fff;
/* transform: translate(-0%, -50%); */
}
@-webkit-keyframes gradient {
0% {
  background-position: 0% 50%;
}
50% {
  background-position: 100% 50%;
}
100% {
  background-position: 0% 50%;
}
}
@keyframes gradient {
0% {
  background-position: 0% 50%;
}
50% {
  background-position: 100% 50%;
}
100% {
  background-position: 0% 50%;
}
}
@media (min-width: 600px) {
.user-speach {
  position: absolute;
  font-size: 15px;
  min-width: 0%;
  max-width: 120%;
  bottom: 30px;
  height: 75px;
  float: inherit;
  left: 0.5%;
  border-radius: 20px;
  padding: 10px;
  color: #fff;
  /* transform: translate(-0%, -50%); */
}
@-webkit-keyframes gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}
@keyframes gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}
}
.user-speach-2 {
position: absolute;
opacity: 1;
font-size: 15px;
max-width: 25%;
bottom: 170;
height: 0px;
float: inherit;
left: 57%;
border-radius: 20px;
color: #fff;
background: linear-gradient(
  -90deg,
  #0f1724,
  #2e3f58,
  #151f2f,
  #19253a,
  #304057,
  #0f1724
);
background-size: 400% 400%;
-webkit-animation: gradient 20s ease infinite;
-animation: gradient 20s ease infinite;
-webkit-animation: animationFrames ease-out 10s;
-webkit-animation-iteration-count: 1;
-webkit-transform-origin: 50% 50%;
-webkit-animation-fill-mode: forwards;
}
.user-speach-3 {
position: absolute;
top: 0px;
font-size: 15px;
max-width: 25%;
height: 50px;
float: inherit;
right: 45.8%;
border-radius: 10px;
color: #fff;
background-size: 400% 400%;
}
.typing {
padding: 15px;
/* background: rgba(37, 50, 68, 0.6);
  border-radius: 15px; */
border-radius: 20px;
min-width: 0%;
margin-left: 0px;
font-family: Arimo, sans-serif;
font-weight: normal;
font-size: 1.26em;
background: rgba(37, 50, 68, 0.2);
-webkit-animation: titleAnimation 20s infinite ease;
-animation: titleAnimation 100s normal forwards ease-in-out;
}
@keyframes titleAnimation {
0% {
  transform: translateY(-48px);
  opacity: 0;
  -webkit-clip-path: polygon(100% 0, 100% 100%, 0 100%, 0 80%);
  clip-path: polygon(100% 0, 100% 100%, 0 100%, 0 80%);
}
20% {
  transform: translateY(0);
  opacity: 1;
  -webkit-clip-path: polygon(100% 0, 100% 100%, 0 100%, 0 0%);
  clip-path: polygon(100% 0, 100% 100%, 0 100%, 0 0%);
}
80% {
  transform: translateY(0);
  opacity: 1;
  -webkit-clip-path: polygon(100% 0, 100% 100%, 0 100%, 0 0%);
  clip-path: polygon(100% 0, 100% 100%, 0 100%, 0 0%);
}
100% {
  transform: translateY(50px);
  opacity: 0;
  -webkit-clip-path: polygon(100% 0, 100% -0%, 0 100%, 0 100%);
  clip-path: polygon(100% 0, 100% -0%, 0 100%, 0 100%);
}
}
.typing2 {
padding: 15px;
/* background: rgba(37, 50, 68, 0.6);
  border-radius: 15px; */
border-radius: 20px;
min-width: 0%;
margin-left: 70px;
font-family: Arimo, sans-serif;
font-weight: normal;
font-size: 1.26em;
background: rgba(37, 50, 68, );
}
.btn-text {
cursor: pointer;
display: inline-block;
font-size: 8px;
font-weight: 100;
line-height: 1.42857;
margin-bottom: 0;
padding: 3px 3px;
text-align: center;
vertical-align: middle;
}
@media (min-width: 600px) {
.btn-text {
  cursor: pointer;
  display: inline-block;
  font-size: 11px;
  font-weight: 300;
  line-height: 1.42857;
  margin-bottom: 0;
  padding: 6px 6px;
  text-align: center;
  vertical-align: middle;
}
}
/* .v-main {
background-color: #304057;
color: white;
height: 100%;
} */
.about {
padding: 0px;
width: 100%;
}
.chart-text {
color: #fff;
text-align: center;
font-size: 1.8rem;
font-weight: normal;
font-family: 'Courier New', Courier, monospace;
}
.tile-title {
color: #fff;
text-align: center;
font-size: 1.3rem;
font-weight: normal;
font-family: Arimo, sans-serif;
}
.chart-title-2 {
color: #fff;
text-align: center;
font-size: 2rem;
font-weight: bold;
font-family: Arimo, sans-serif;
}
@media only screen and (max-width: 600px) {
.chart-title-2 {
  color: #fff;
  text-align: center;
  font-size: 2.2rem;
  font-weight: bold;
  font-family: Arimo, sans-serif;
}
}
.theme-bg-card-5 {
background: rgba(48, 64, 87, 0.0);
border-radius: 25px;
width: 35%;
}
@media only screen and (max-width: 600px) {
.theme-bg-card-5 {
background: rgba(48, 64, 87, 0.6);
width: 50%;
}
}
.theme-bg-card-8 {
background: rgba(48, 64, 87, 0.85);
outline-color: #42da91;
color: #fff;
border: 1px solid transparent;
box-shadow: 0 2px 4px rgba(0, 0, 0, 0.5), 0 6px 6px rgba(0, 0, 0, 0.3);
height: 100%;
border-radius: 30px;
}

.chart-content {
opacity: 0.7;
text-align: center;
margin-left: 0%;
top: -75px;
background: rgba(12, 22, 27, 0.4);
outline-color: rgba(90, 128, 191, 0.5);
outline-style: solid;
animation: glow 1800ms ease-out infinite alternate;
border-color: #5a80bf;
box-shadow: 0 0 5px rgba(120, 204, 226, 0.4), inset 0 0 10px rgba(120, 204, 226, 0.2), 0 4px 0 #000;
color: #efe;
outline-width: 2px;
padding: 15px;
border-radius: 10px;
margin: 10px;
}

@-webkit-keyframes gradient {
0% {
  background-position: 0% 50%;
}
50% {
  background-position: 100% 50%;
}
100% {
  background-position: 0% 50%;
}
}

@keyframes gradient {
0% {
  background-position: 0% 50%;
}
50% {
  background-position: 100% 50%;
}
100% {
  background-position: 0% 50%;
}
height: 150%;
}

.db-content {
background: #304057;
background-size: 400% 400%;
padding: 40px;
min-height: 88vh;
-animation: gradient 25s ease infinite;
}
.btn-right {
display: flex;
justify-content: flex-end;
flex-direction: row;
}
.mg-lr14 {
margin: 0px 14px;
}
.scroll {
overflow-y: scroll;
height: 100%;
}
.theme-bg-card {
background: rgba(48, 64, 87, 0.8);
outline-color: #42da91;
color: #fff;
border: 1px solid transparent;
box-shadow: 0 2px 4px rgba(0, 0, 0, 0.5), 0 6px 6px rgba(0, 0, 0, 0.3);
height: 400px;
}
.theme-bg-card:hover {
background: rgba(48, 64, 87, 0.8);
outline-color: #42da91;
outline-style: solid;
animation: glow 1800ms ease-out infinite alternate;
border-color: #42da91;
box-shadow: 0 0 10px rgba(90, 128, 191, 0.2),
  inset 0 0 10px rgba(90, 128, 191, 0.1), 0 0px 0 #000;
color: #efe;
outline: 20px;
}


.theme-bg-card-sales {
background: rgb(84, 89, 94);
outline-color: #42da91;
color: #fff;
border: 1px solid transparent;
box-shadow: 0 2px 4px rgba(0, 0, 0, 0.5), 0 6px 6px rgba(0, 0, 0, 0.3);
height: 68vh;
top: -7rem;
}
.theme-bg-card-sales:hover {
outline-color: #42da91;
outline-style: solid;
animation: glow 1800ms ease-out infinite alternate;
border-color: #42da91;
box-shadow: 0 0 10px rgba(90, 128, 191, 0.2),
  inset 0 0 10px rgba(90, 128, 191, 0.1), 0 0px 0 #000;
color: #efe;
outline: 20px;
}
.theme-bg-card-4 {
background: rgba(48, 64, 87, 0.85);
outline-color: #42da91;
color: #fff;
border: 1px solid transparent;
box-shadow: 0 2px 4px rgba(0, 0, 0, 0.5), 0 6px 6px rgba(0, 0, 0, 0.3);
height: 10vh;
border-radius: 30px;
}
.form-control {
border: 1px solid #5e6570;
padding: 20px 20px;
margin-block: 3px 5px;
border-radius: 5px;
font-size: 14px;
background: transparent;
color: rgb(36, 212, 65);
}
@media only screen and (max-width: 600px) {
.form-control {
border: 1px solid #5e6570;
padding: 20px 20px;
margin-block: 3px 5px;
border-radius: 10px;
font-size: 12px;
background: transparent;
color: rgb(36, 212, 65);
}
}
.form-control-2 {
border: 1px solid #5e6570;
padding: 20px 20px;
margin-block: 3px 5px;
border-radius: 5px;
font-size: 14px;
background: transparent;
color: rgb(36, 212, 65);
}
@media only screen and (max-width: 600px) {
.form-control-2 {
border: 1px solid #5e6570;
padding: 20px 20px;
margin-block: 3px 5px;
border-radius: 30px;
font-size: 12px;
background: transparent;
color: rgb(36, 212, 65);
}
}
.form-control-3 {
display: block;
min-width: 480px;
line-height: 2.5;
font-size: 18px;
color: rgb(36, 212, 65);
border-radius: 20px;
padding-block: 20px;
margin-block: 5px;
border: 1px solid transparent;
}
@media only screen and (max-width: 600px) {
.form-control-3 {
display: block;
min-width: 480px;
line-height: 2.5;
font-size: 16px;
color: rgb(36, 212, 65);
border-radius: 20px;
padding-block: 20px;
margin-block: 5px;
border: 1px solid transparent;
}
}
.form-title {
padding-block: 5px;
color: #fff;
text-align: center;
font-size: 0.8rem;
font-weight: thin;
font-family: Arimo, sans-serif;
}
@media only screen and (max-width: 600px) {
.form-title {
  padding-block: 5px;
  color: #fff;
  text-align: center;
  font-size: 0.7rem;
  font-weight: thin;
  font-family: Arimo, sans-serif;
}
}
.thrash {
font-size: 20px;
cursor: pointer;
}
.card-animate-2 {
animation-name: slideExpandUp;
/* position: relative;
position-fromtop: 100px; */
animation-duration: 3s;
transition: opacity 1s Elastic.easeIn;
}
.slideExpandUp {
animation-name: slideExpandUp;
-webkit-animation-name: slideExpandUp;
animation-duration: 2.7s;
-webkit-animation-duration: 2.7s;
animation-timing-function: ease-out;
-webkit-animation-timing-function: ease -out;
visibility: visible !important;
}
@keyframes slideExpandUp {
0% {
  -webkit-transform: translateY(10%) scaleX(0.94);
}
30% {
  -webkit-transform: translateY(-5%) scaleX(0.95);
}
40% {
  -webkit-transform: translateY(3%) scaleX(0.96);
}
50% {
  -webkit-transform: translateY(0%) scaleX(1);
}
}
@-webkit-keyframes slideExpandUp {
0% {
  -webkit-transform: translateY(10%) scaleX(0.94);
}
30% {
  -webkit-transform: translateY(-5%) scaleX(0.95);
}
40% {
  -webkit-transform: translateY(3%) scaleX(0.96);
}
50% {
  -webkit-transform: translateY(0%) scaleX(1);
}
}
/* .button {
border-radius: 30px;
padding: 10px;
width: 10px;
border: outline;
background: #304057;
opacity: 0.9;
cursor: pointer;
margin-left: 0px;
margin-right: auto;
left: 0px;
right: 0px;
align: center;
outline-color: #5a80bf;
outline-style: solid;
animation: glow 1800ms ease-out infinite alternate;
border-color: #5a80bf;
box-shadow: 0 0 5px rgba(90, 128, 191, 0.2),
  inset 0 0 3px rgba(90, 128, 191, 0.1), 0 2px 0 #000;
outline: none;
}
@keyframes glow {
  0% {
    border-color: #11ece5;
    box-shadow: 0 0 5px rgba(90, 128, 191, 0.2),
      inset 0 0 6px rgba(90, 128, 191, 0.4), 0 2px 0 #000;
  }
  100% {
    border-color: #11ece5;
    box-shadow: 0 0 8px rgba(90, 128, 191, 0.8),
      inset 0 0 10px rgba(90, 128, 191, 0.8), 0 2px 0 #000;
  }
}
@media only screen and (max-width: 600px) {

.button {
border-radius: 40px;
padding: 5px;
width: 10px;
border: outline;
background: #304057;
opacity: 0.9;
cursor: pointer;
margin-left: 0px;
margin-right: auto;
left: 0px;
right: 0px;
align: center;
outline-color: #5a80bf;
outline-style: solid;
animation: glow 1800ms ease-out infinite alternate;
border-color: #5a80bf;
box-shadow: 0 0 5px rgba(90, 128, 191, 0.2),
  inset 0 0 3px rgba(90, 128, 191, 0.1), 0 2px 0 #000;
outline: none;
}
@keyframes glow {
  0% {
    border-color: #11ece5;
    box-shadow: 0 0 5px rgba(90, 128, 191, 0.2),
      inset 0 0 6px rgba(90, 128, 191, 0.4), 0 2px 0 #000;
  }
  100% {
    border-color: #11ece5;
    box-shadow: 0 0 8px rgba(90, 128, 191, 0.8),
      inset 0 0 10px rgba(90, 128, 191, 0.8), 0 2px 0 #000;
  }
}
} */
.field {
margin-bottom: 30px;
padding: 30px;
border-radius: 20px;
  border-color: rgb(36, 212, 65);
border-radius: 20px;
padding-block: 20px;
margin-block: 5px;
border: 1px solid transparent;
}
.field label {
display: block;
font-size: 16px;
color: rgb(255, 255, 255);
}
.field input {
display: block;
min-width: 500px;
line-height: 2.5;
font-size: 16px;
color: rgb(36, 212, 65);
border-radius: 20px;
padding-block: 10px;
margin-block: 5px;
border: 1px solid transparent;
}
input[type="submit"] {
display: block;
padding: 10px 40px;
font-size: 14px;
background-color: rgb(36, 212, 65);
color: #fff;
border: none;
background: rgb(36, 212, 65, 0.4);
outline-color: #42da91;
color: #fff;
border: 1px solid transparent;
height: 50px;
}
.card-animate {
animation-name: slideExpandDown;
/* position: relative;
position-fromtop: 100px; */
animation-duration: 3s;
transition: opacity 1s easeIn;
}
.slideExpandDown {
animation-name: slideExpandDown;
-webkit-animation-name: slideExpandDown;
animation-duration: 2.7s;
-webkit-animation-duration: 2.7s;
animation-timing-function: ease-out;
-webkit-animation-timing-function: ease -out;
visibility: visible !important;
}
@keyframes slideExpandDown {
0% {
  transform: translateY(100%) scaleX(0.94);
}
30% {
  transform: translateY(-4%) scaleX(0.95);
}
40% {
  transform: translateY(2%) scaleX(0.96);
}
50% {
  transform: translateY(0%) scaleX(1);
}
}
@-webkit-keyframes slideExpandDown {
0% {
  -webkit-transform: translateY(100%) scaleX(0.94);
}
30% {
  -webkit-transform: translateY(-4%) scaleX(0.95);
}
40% {
  -webkit-transform: translateY(2%) scaleX(0.96);
}
50% {
  -webkit-transform: translateY(0%) scaleX(1);
}
}
.popup-container {
max-height: 90vh;
width: 90vw;
padding: 10px 40px;
}
.font-weight-thin {
margin-top: 2rem;
margin-bottom: 2rem;
font-weight: 600;
}
.d-flex-row {
display: flex;
flex-direction: row;
}
.d-flex-col {
display: flex;
flex-direction: column;
}
.date-picker {
flex: 1 1 0%;
padding: 30px;
border: 2px solid rgba(120,181,156,.2);
height: 60px;
width: 320px;
color: #fff;
margin: 12px 40px;
border-radius: 15px;
}
.date-picker-2 {
flex: 1 1 0%;
padding: 17px;
border: 1px solid #fff;
height: 53px;
width: auto;
color: #fff;
margin: 0 14px;
border-radius: 5px;
}
.form-control {
border: 1px solid #5e6570;
padding: 20px 20px;
margin-block: 3px 5px;
border-radius: 5px;
font-size: 14px;
background: transparent;
color: #fff;
}
@media only screen and (max-width: 600px) {
.form-control {
border: 1px solid #5e6570;
padding: 20px 20px;
margin-block: 3px 5px;
border-radius: 10px;
font-size: 12px;
background: transparent;
color: #fff;
}
}
.form-control-2 {
border: 1px solid #5e6570;
padding: 20px 20px;
margin-block: 3px 5px;
border-radius: 5px;
font-size: 14px;
background: transparent;
color: #fff;
}
@media only screen and (max-width: 600px) {
.form-control-2 {
border: 1px solid #5e6570;
padding: 20px 20px;
margin-block: 3px 5px;
border-radius: 10px;
font-size: 12px;
background: transparent;
color: #fff;
}
}
.space1 {
height: 50px;
}
.space2 {
height: 100px;
}
.space3 {
height: 50px;
}
.action-btn {
font-size: 20px;
cursor: pointer;
position: relative;
top: 5px;
}
.product-list {
position: absolute;
margin-left: 160px;
margin-top: 38px;
width: 50%;
padding: 0px;
list-style: none;
background: rgba(48, 64, 87, 0.3);
color: rgb(255, 255, 255);
line-height: 2;
max-height: 200px;
overflow: auto;
border: 1px solid #7c7c7c;
border-radius: 8px;
}
.item {
padding: 10px;
border-bottom: 1px solid #ccc;
cursor: pointer;
}
.item:hover {
background: rgba(48, 64, 87, 0.8);
}
.calc {
width: 200px;
margin-bottom: 20px;
}
.loader {
border: 3px solid #f3f3f3;
border-radius: 50%;
border-top: 3px solid #3498db;
width: 15px;
height: 15px;
-webkit-animation: spin 2s linear infinite; /* Safari */
animation: spin 2s linear infinite;
position: relative;
margin-top: 12px;
margin-left: -15px;
}
/* Safari */
@-webkit-keyframes spin {
0% {
  -webkit-transform: rotate(0deg);
}
100% {
  -webkit-transform: rotate(360deg);
}
}
@keyframes spin {
0% {
  transform: rotate(0deg);
}
100% {
  transform: rotate(360deg);
}
}
</style>

<style lang="scss">
$base-duration: 500ms;
// Colors
$color-1: rgba(48, 64, 87, 0.85);
$color-2: rgba(48, 64, 87, 0.2);
$color-3: #2ecc71;
// Breakpoints
$sm: new-breakpoint(min-width 320px);
$med: new-breakpoint(min-width 768px);
$lg: new-breakpoint(min-width 1024px);
*, *:before, *:after {
box-sizing: border-box;
outline: none;
}
.hide { display: none;
}
.button {
position: relative;
display: flex;
flex-direction: column;
align-items: center;
justify-content: center;
width: 100%;
margin: 0;
padding: 1.5rem 3.125rem;
background-color: $color-2;
border: none;
border-radius: 25px; 
box-shadow: 0 12px 24px 0 rgba(0,0,0,0.2);

//box-shadow:
//	0 -1.25rem 1rem -1.5rem rgba(black, 0.4),
//	0 0.5rem 1.75rem -0.25rem rgba(black, 0.3),
//	0 1.25rem 2.5rem rgba(black, 0.2);
font-weight: 300;
text-transform: uppercase;
//transition: $base-duration ease;
overflow: hidden; 

&:before {
  position: absolute;
  content: '';
  bottom: 0;
  left: 0;
  width: 0%;
  height: 100%;
  background-color: lighten($color-3,10%);
}

span {
  position: absolute;
  line-height: 0;
  
  i {
    transform-origin: center center;
  }
  &:nth-of-type(1) {
    top: 50%;
    transform: translateY(-50%);
  }
  
  &:nth-of-type(2) {
    top: 100%;
    transform: translateY(0%);
    font-size: 24px;
  }
  
  &:nth-of-type(3) {
    display: none;
  }
}
}
.active {
background-color: $color-3;

&:before {
  width: 100%;
  transition: width 3s linear;
}
span {
  
  &:nth-of-type(1) {
    top: -100%;
    transform: translateY(-50%); 
  }
  &:nth-of-type(2) {
    top: 50%;
    transform: translateY(-50%);
    i {
      animation: loading $base-duration linear infinite;
    }
  }
  
  &:nth-of-type(3) {
    display: none;
  }
}
}
.finished {
background-color: lighten($color-3,10%);

.submit {
  display: none; 
}

.loading {
  display: none;
}

.check {
  display: block !important;
  font-size: 24px;
  animation: scale 0.5s linear;
  
  i {
    transform-origin: center center;
  }
}

}
@keyframes loading {
100% { transform: rotate(360deg); }
}
@keyframes scale {
0%   { transform: scale(10); }
50%  { transform: scale(0.2); }
70%  { transform: scale(1.2); }
90%  { transform: scale(0.7); }
100% { transform: scale(1); }
}
</style>

<style lang="scss">
table.blueTable {
border-radius: 40px;
border: 0.2px solid #1c6ea4;
// background-color: #eeeeeed4;
background-color: dark;
width: 93%;
text-align: center;
margin-left: 66px;
border-collapse: collapse;
}
table.blueTable td, table.blueTable th {
padding: 3px 2px;
}
table.blueTable tbody td {
font-size: 15px;
color: primary;
}
table.blueTable tr:nth-child(even) {
// background: #98a7b334;
// opacity: 0.8;
}
table.blueTable thead {
background: #304057;
border-radius: 5px;
}
table.blueTable thead th {
text-align: center;
font-size: 16px;
font-weight: normal;
font-family: 'Roboto', sans-serif;
color: #FFFFFF;
border-left: 2px solid #D0E4F5;
}
table.blueTable thead th:first-child {
border-left: none;
}

table.blueTable tfoot {
font-size: 14px;
font-weight: bold;
color: #FFFFFF;
background: #D0E4F5;
background: -moz-linear-gradient(top, #dcebf7 0%, #d4e6f6 66%, #D0E4F5 100%);
background: -webkit-linear-gradient(top, #dcebf7 0%, #d4e6f6 66%, #D0E4F5 100%);
background: linear-gradient(to bottom, #dcebf7 0%, #d4e6f6 66%, #D0E4F5 100%);
border-top: 2px solid #444444;
}
table.blueTable tfoot td {
font-size: 14px;
}
table.blueTable tfoot .links {
text-align: right;
}
table.blueTable tfoot .links a{
display: inline-block;
background: #1C6EA4;
color: #FFFFFF;
padding: 2px 8px;
border-radius: 5px;
}
</style>

<style scoped>
.first-place {
background-color: rgb(105, 223, 105);
}
.second-place {
background-color: rgb(32, 124, 158);
}
.third-place {
background-color: rgba(32, 124, 158, 0.4);
}
.fourth-place {
background-color: rgba(151, 151, 151, 0);
}
.fifth-place {
background-color: rgba(32, 124, 158, 0.05);
}
.sixth-place {
background-color: rgba(151, 151, 151, 0);
}
.seventh-place {
background-color: rgba(32, 124, 158, 0.05);
}
.eighth-place {
background-color: rgba(151, 151, 151, 0);
}
.ninth-place {
background-color: rgba(32, 124, 158, 0.05);
}

.data-table-iframe {
margin-top: 530px;
height: 50px;
width: 100%; /* adjust according to your needs */
}

.data-table-iframe.show-data-table {
height: 600px; /* Adjust this value according to the size needed for the data table */
width: 100%; /* adjust according to your needs */
}

.default-size {
height: 50px;
width: 100%; /* adjust according to your needs */
}
.slide-fade-enter-active {
transition: all 0.3s ease;
}
.slide-fade-leave-active {
transition: all 0.8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
transform: translateX(-10px);
opacity: 0;
}
.report-frame {
width: 100%;
height: 300px;
border: 1px solid #ccc;
}
.bg-content {
background: #131f25c6;
padding: 0px;
min-height: 140vh;
-webkit-animation: gradient 25s ease infinite;
-animation: gradient 25s ease infinite;
}
@-webkit-keyframes gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

@keyframes gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
  height: 150%;
}

@media only screen and (max-width: 600px) {
 .bg-content {
  background: #131f25e7;
padding: 0px;
min-height: 100vh;
-webkit-animation: gradient 25s ease infinite;
-animation: gradient 25s ease infinite;
}
@-webkit-keyframes gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

@keyframes gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
  height: 150%;
} 
}
.avatar-name {
position: relative;
top: 10px;
font-weight: 600;
margin-left: 8px;
margin-right: 5px;
}
.user-speach {
position: center;
font-size: 12px;
min-width: 0%;
max-width: 120%;
bottom: 15px;
height: 75px;
float: inherit;
left: -25px;
border-radius: 20px;
padding: 15px;
color: #fff;
/* transform: translate(-0%, -50%); */
}

@-webkit-keyframes gradient {
0% {
background-position: 0% 50%;
}
50% {
background-position: 100% 50%;
}
100% {
background-position: 0% 50%;
}
}

@keyframes gradient {
0% {
background-position: 0% 50%;
}
50% {
background-position: 100% 50%;
}
100% {
background-position: 0% 50%;
}
}

@media (min-width: 600px) {
.user-speach {
position: absolute;
font-size: 15px;
min-width: 0%;
max-width: 120%;
bottom: 30px;
height: 75px;
float: inherit;
left: 0.5%;
border-radius: 20px;
padding: 10px;
color: #fff;
/* transform: translate(-0%, -50%); */
}

@-webkit-keyframes gradient {
0% {
  background-position: 0% 50%;
}
50% {
  background-position: 100% 50%;
}
100% {
  background-position: 0% 50%;
}
}

@keyframes gradient {
0% {
  background-position: 0% 50%;
}
50% {
  background-position: 100% 50%;
}
100% {
  background-position: 0% 50%;
}
}
}

.btn-text {
cursor: pointer;
display: inline-block;
font-size: 8px;
font-weight: 100;
line-height: 1.42857;
margin-bottom: 0;
padding: 3px 3px;
text-align: center;
vertical-align: middle;
}
@media (min-width: 600px) {
.btn-text {
cursor: pointer;
display: inline-block;
font-size: 11px;
font-weight: 300;
line-height: 1.42857;
margin-bottom: 0;
padding: 6px 6px;
text-align: center;
vertical-align: middle;
}
}
.about {
padding: 0px;
width: 100%;
}
.db-content {
background: #304057;
background-size: 400% 400%;
padding: 40px;
min-height: 88vh;
-webkit-animation: gradient 25s ease infinite;
-animation: gradient 25s ease infinite;
}
.btn-right {
display: flex;
justify-content: flex-end;
flex-direction: row;
}
.mg-lr14 {
margin: 0px 14px;
}
.scroll {
overflow-y: scroll;
height: 100%;
}
.theme-bg-card {
background: rgba(48, 64, 87, 0.8);
outline-color: #42da91;
color: #fff;
border: 1px solid transparent;
box-shadow: 0 2px 4px rgba(0, 0, 0, 0.5), 0 6px 6px rgba(0, 0, 0, 0.3);
height: 400px;
}
.theme-bg-card:hover {
background: rgba(48, 64, 87, 0.8);
outline-color: #42da91;
outline-style: solid;
animation: glow 1800ms ease-out infinite alternate;
border-color: #42da91;
box-shadow: 0 0 10px rgba(90, 128, 191, 0.2),
inset 0 0 10px rgba(90, 128, 191, 0.1), 0 0px 0 #000;
color: #efe;
outline: 20px;
}
.theme-bg-card-2 {
background: rgba(12, 22, 27, 0.1);
outline-color: #5a80bf;
color: rgb(255, 255, 255);
padding: 10px; 
top: 0px
}
@media only screen and (max-width: 600px) {
.theme-bg-card-2 {
background: rgba(12, 22, 27, 0.0);
outline-color: #5a80bf;
color: rgb(255, 255, 255);
padding: 10px; 
top:0px
}
}

/* .theme-bg-card-sales:hover {
background: rgba(48, 64, 87, 0.9);
outline-color: #42da91;
outline-style: solid;
animation: glow 1800ms ease-out infinite alternate;
border-color: #42da91;
box-shadow: 0 0 10px rgba(90, 128, 191, 0.2),
inset 0 0 10px rgba(90, 128, 191, 0.1), 0 0px 0 #000;
color: #efe;
outline: 20px;
} */
.theme-bg-card-4 {
background: rgba(48, 64, 87, 0.85);
outline-color: #42da91;
color: #fff;
border: 1px solid transparent;
box-shadow: 0 2px 4px rgba(0, 0, 0, 0.5), 0 6px 6px rgba(0, 0, 0, 0.3);
height: 10vh;
border-radius: 30px;
}

.theme-bg-card-5 {
background: rgba(48, 64, 87, 0.6);
outline-color: #5a80bf;
color: #fff;
width: 35%;
}


@media only screen and (max-width: 600px) {
.theme-bg-card-5 {
background: rgba(48, 64, 87, 0.6);
outline-color: #5a80bf;
color: #fff;
width: 50%;
}
}
.theme-bg-card-6 {
background: rgba(12, 22, 27, 0.4);
outline-color: #5a80bf;
color: #fff;
}
.theme-bg-card-7 {
background: rgba(12, 22, 27, 0.0);
outline-color: #5a80bf;
color: rgb(255, 255, 255);
padding: 10px;
margin-left: -10px; 
top: 20px
}
@media only screen and (max-width: 600px) {
.theme-bg-card-7 {
background: rgba(12, 22, 27, 0.0);
outline-color: #5a80bf;
color: rgb(255, 255, 255);
padding: 10px; 
top:0px
}
}
.chart-text {
color: #fff;
text-align: center;
font-size: 4rem;
font-weight: bold;
font-family: 'Courier New', Courier, monospace;
}
.tile-title {
color: #fff;
text-align: center;
font-size: 1.3rem;
font-weight: normal;
font-family: Arimo, sans-serif;
}
.chart-title-2 {
color: #030303;
text-align: center;
font-size: 1.8rem;
font-weight: bold;
font-family: Arimo, sans-serif;
}
@media only screen and (max-width: 600px) {
.chart-title-2 {
color: #030303;
text-align: center;
font-size: 1.4rem;
font-weight: bold;
font-family: Arimo, sans-serif;
}
}
.chart-title-2-2 {
color: #fff;
text-align: center;
font-size: 1rem;
font-weight: thin;
font-family: Arimo, sans-serif;
}


.theme-bg-card-5 {
background: rgba(48, 64, 87, 0.0);
border-radius: 25px;
width: 35%;

}


@media only screen and (max-width: 600px) {
.theme-bg-card-5 {
background: rgba(48, 64, 87, 0.6);

width: 50%;
}
}
.field {
margin-bottom: 30px;
padding: 30px;
border-radius: 20px;
border-color: rgb(36, 212, 65);
border-radius: 20px;
padding-block: 20px;
margin-block: 5px;
border: 1px solid transparent;

}

.field label {
display: block;
font-size: 16px;
color: rgb(255, 255, 255);
}

.field input {
display: block;
min-width: 500px;
line-height: 2.5;
font-size: 16px;
color: rgb(36, 212, 65);
border-radius: 20px;
padding-block: 10px;
margin-block: 5px;
border: 1px solid transparent;
}

input[type="submit"] {
display: block;
padding: 10px 40px;
font-size: 14px;
background-color: rgb(36, 212, 65);
color: #fff;
border: none;
background: rgb(36, 212, 65, 0.4);
outline-color: #42da91;
color: #fff;
border: 1px solid transparent;
height: 50px;
}


.chart-title-2-2 {
text-align: center;
font-size: 1.3rem;
font-weight: 500;
color: #42da91;
font-family: Arial, Helvetica, sans-serif;
padding: 20px;
}
@media only screen and (max-width: 600px) {
.chart-title-2-2 {
text-align: center;
font-size: 12px;
font-weight: 500;
color: #42da91;
font-family: Arial, Helvetica, sans-serif;
padding: 5px;
}
}

.field {
margin-bottom: 30px;
padding: 30px;
border-radius: 20px;

}

.field label {
display: block;
font-size: 16px;
color: rgb(255, 255, 255);
}

.field input {
display: block;
min-width: 500px;
line-height: 2.5;
font-size: 16px;
color: rgb(0, 0, 0);
border-radius: 20px;
padding-block: 20px;
margin-block: 5px;
border: 1px solid transparent;
}

input[type="submit"] {
display: block;
padding: 10px 40px;
font-size: 14px;
background-color: #4460AA;
color: #000000;
border: none;
background: rgba(48, 64, 87, 0.8);
outline-color: #42da91;
border: 1px solid transparent;
height: 50px;
}
/* 
.button {
border-radius: 30px;
padding: 8px;
width: 3px;
border: outline;
background: #304057;
opacity: 0.9;
cursor: pointer;
margin-left: auto;
margin-right: auto;
align: center;
outline-color: #5a80bf;
outline-style: solid;
animation: glow 1800ms ease-out infinite alternate;
border-color: #5a80bf;
box-shadow: 0 0 5px rgba(90, 128, 191, 0.2),
inset 0 0 3px rgba(90, 128, 191, 0.1), 0 2px 0 #000;
outline: none;
}
@keyframes glow {
0% {
  border-color: #11ece5;
  box-shadow: 0 0 5px rgba(90, 128, 191, 0.2),
    inset 0 0 6px rgba(90, 128, 191, 0.4), 0 2px 0 #000;
}
100% {
  border-color: #11ece5;
  box-shadow: 0 0 8px rgba(90, 128, 191, 0.8),
    inset 0 0 10px rgba(90, 128, 191, 0.8), 0 2px 0 #000;
}
}
@media only screen and (max-width: 600px) {

.button {
border-radius: 40px;
padding: 5px;
width: 5px;
border: outline;
background: #304057;
opacity: 0.9;
cursor: pointer;
margin-left: auto;
margin-right: auto;
align: center;
outline-color: #5a80bf;
outline-style: solid;
animation: glow 1800ms ease-out infinite alternate;
border-color: #5a80bf;
box-shadow: 0 0 5px rgba(90, 128, 191, 0.2),
inset 0 0 3px rgba(90, 128, 191, 0.1), 0 2px 0 #000;
outline: none;
}
@keyframes glow {
0% {
  border-color: #11ece5;
  box-shadow: 0 0 5px rgba(90, 128, 191, 0.2),
    inset 0 0 6px rgba(90, 128, 191, 0.4), 0 2px 0 #000;
}
100% {
  border-color: #11ece5;
  box-shadow: 0 0 8px rgba(90, 128, 191, 0.8),
    inset 0 0 10px rgba(90, 128, 191, 0.8), 0 2px 0 #000;
}
}
} */

.button2  {
border-radius: 30px;
padding:  0px;
border: outline;
background: #304057;
opacity: 0.9;
cursor: pointer;
margin-left: auto;
margin-right: auto;
outline-color: #5a80bf;
outline-style: solid;
animation: glow 1800ms ease-out infinite alternate;
border-color: #5a80bf;
box-shadow: 0 0 5px rgba(90, 128, 191, 0.2),
inset 0 0 3px rgba(90, 128, 191, 0.1), 0 2px 0 #000;
outline: none;
}
@keyframes glow {
0% {
  border-color: #11ece5;
  box-shadow: 0 0 5px rgba(90, 128, 191, 0.2),
    inset 0 0 6px rgba(90, 128, 191, 0.4), 0 2px 0 #000;
}
100% {
  border-color: #11ece5;
  box-shadow: 0 0 8px rgba(90, 128, 191, 0.8),
    inset 0 0 10px rgba(90, 128, 191, 0.8), 0 2px 0 #000;
}
}

.chart-content {
opacity: 0.7;
text-align: center;
margin-left: 0%;
top: -75px;
background: rgba(12, 22, 27, 0.4);
outline-color: rgba(90, 128, 191, 0.5);
outline-style: solid;
animation: glow 1800ms ease-out infinite alternate;
border-color: #5a80bf;
box-shadow: 0 0 5px rgba(120, 204, 226, 0.4), inset 0 0 10px rgba(120, 204, 226, 0.2), 0 4px 0 #000;
color: #efe;
outline-width: 2px;
padding: 15px;
border-radius: 10px;
margin: 10px;
}

@-webkit-keyframes gradient {
0% {
background-position: 0% 50%;
}
50% {
background-position: 100% 50%;
}
100% {
background-position: 0% 50%;
}
}

@keyframes gradient {
0% {
background-position: 0% 50%;
}
50% {
background-position: 100% 50%;
}
100% {
background-position: 0% 50%;
}
height: 150%;
}


.thrash {
font-size: 20px;
cursor: pointer;
}
.card-animate-2 {
animation-name: slideExpandUp;
/* position: relative;
position-fromtop: 100px; */
animation-duration: 3s;
transition: opacity 1s Elastic.easeIn;
}

.slideExpandUp {
animation-name: slideExpandUp;
-webkit-animation-name: slideExpandUp;

animation-duration: 2.7s;
-webkit-animation-duration: 2.7s;

animation-timing-function: ease-out;
-webkit-animation-timing-function: ease -out;

visibility: visible !important;
}

@keyframes slideExpandUp {
0% {
-webkit-transform: translateY(10%) scaleX(0.94);
}
30% {
-webkit-transform: translateY(-5%) scaleX(0.95);
}
40% {
-webkit-transform: translateY(3%) scaleX(0.96);
}
50% {
-webkit-transform: translateY(0%) scaleX(1);
}
}

@-webkit-keyframes slideExpandUp {
0% {
-webkit-transform: translateY(10%) scaleX(0.94);
}
30% {
-webkit-transform: translateY(-5%) scaleX(0.95);
}
40% {
-webkit-transform: translateY(3%) scaleX(0.96);
}
50% {
-webkit-transform: translateY(0%) scaleX(1);
}
}

.card-animate {
animation-name: slideExpandDown;
/* position: relative;
position-fromtop: 100px; */
animation-duration: 3s;
transition: opacity 1s Elastic.easeIn;
}
.slideExpandDown {
animation-name: slideExpandDown;
-webkit-animation-name: slideExpandDown;
animation-duration: 2.7s;
-webkit-animation-duration: 2.7s;
animation-timing-function: ease-out;
-webkit-animation-timing-function: ease -out;
visibility: visible !important;
}
@keyframes slideExpandDown {
0% {
transform: translateY(100%) scaleX(0.94);
}
30% {
transform: translateY(-4%) scaleX(0.95);
}
40% {
transform: translateY(2%) scaleX(0.96);
}
50% {
transform: translateY(0%) scaleX(1);
}
}
@-webkit-keyframes slideExpandDown {
0% {
-webkit-transform: translateY(100%) scaleX(0.94);
}
30% {
-webkit-transform: translateY(-4%) scaleX(0.95);
}
40% {
-webkit-transform: translateY(2%) scaleX(0.96);
}
50% {
-webkit-transform: translateY(0%) scaleX(1);
}
}
.font-weight-thin {
margin-top: 2rem;
margin-bottom: 2rem;
font-weight: 600;
}
.d-flex-row {
display: flex;
flex-direction: row;
}
.d-flex-col {
display: flex;
flex-direction: column;
}
.date-picker {
flex: 1 1 0%;
padding: 17px;
border: 1px solid #fff;
height: 53px;
width: auto;
color: #fff;
margin: 0 14px;
border-radius: 5px;
}
.form-control {
border: 1px solid #5e6570;
padding: 20px 20px;
margin-block: 3px 5px;
border-radius: 5px;
font-size: 14px;
background: transparent;
color: rgb(36, 212, 65);
}
@media only screen and (max-width: 600px) {
.form-control {
border: 1px solid #5e6570;
padding: 20px 20px;
margin-block: 3px 5px;
border-radius: 10px;
font-size: 12px;
background: transparent;
color: rgb(36, 212, 65);
}
}
.form-control-2 {
border: 1px solid #5e6570;
padding: 20px 20px;
margin-block: 3px 5px;
border-radius: 5px;
font-size: 14px;
background: transparent;
color: rgb(255, 255, 255);

}
@media only screen and (max-width: 600px) {
.form-control-2 {
border: 1px solid #5e6570;
padding: 20px 20px;
margin-block: 3px 5px;
border-radius: 10px;
font-size: 12px;
background: transparent;
color: rgb(36, 212, 65);
}
}
.form-control-3 {
display: block;
min-width: 480px;
line-height: 2.5;
font-size: 18px;
color: rgb(36, 212, 65);
border-radius: 20px;
padding-block: 20px;
margin-block: 5px;
border: 1px solid transparent;
}
@media only screen and (max-width: 600px) {
.form-control-3 {
display: block;
min-width: 480px;
line-height: 2.5;
font-size: 16px;
color: rgb(36, 212, 65);
border-radius: 20px;
padding-block: 20px;
margin-block: 5px;
border: 1px solid transparent;
}
}
.space2 {
height: 50px;
}
.action-btn {
font-size: 20px;
cursor: pointer;
position: relative;
top: 5px;
}
.typing {
padding: 15px;
/* background: rgba(37, 50, 68, 0.6);
border-radius: 15px; */
border-radius: 20px;
min-width: 0%;
margin-left: 0px;
font-family: Arimo, sans-serif;
font-weight: normal;
font-size: 1.26em;
background: rgba(37, 50, 68, 0.2);
-webkit-animation: titleAnimation 20s infinite ease;
-animation: titleAnimation 100s normal forwards ease-in-out;
}

@keyframes titleAnimation {
0% {
transform: translateY(-48px);
opacity: 0;
-webkit-clip-path: polygon(100% 0, 100% 100%, 0 100%, 0 80%);
clip-path: polygon(100% 0, 100% 100%, 0 100%, 0 80%);
}
20% {
transform: translateY(0);
opacity: 1;
-webkit-clip-path: polygon(100% 0, 100% 100%, 0 100%, 0 0%);
clip-path: polygon(100% 0, 100% 100%, 0 100%, 0 0%);
}
80% {
transform: translateY(0);
opacity: 1;
-webkit-clip-path: polygon(100% 0, 100% 100%, 0 100%, 0 0%);
clip-path: polygon(100% 0, 100% 100%, 0 100%, 0 0%);
}
100% {
transform: translateY(50px);
opacity: 0;
-webkit-clip-path: polygon(100% 0, 100% -0%, 0 100%, 0 100%);
clip-path: polygon(100% 0, 100% -0%, 0 100%, 0 100%);
}
}
.typing2 {
padding: 15px;
/* background: rgba(37, 50, 68, 0.6);
border-radius: 15px; */
border-radius: 20px;
min-width: 0%;
margin-left: 60px;
font-family: Arimo, sans-serif;
font-weight: normal;
font-size: 1.26em;
background: rgba(37, 50, 68, );

}

.product-list {
position: absolute;
margin-left: 160px;
margin-top: 38px;
width: 50%;
padding: 0px;
list-style: none;
background: rgba(48, 64, 87, 0.3);
color: rgb(255, 255, 255);
line-height: 2;
max-height: 200px;
overflow: auto;
border: 1px solid #7c7c7c;
border-radius: 8px;
}
.item {
padding: 10px;
border-bottom: 1px solid #ccc;
cursor: pointer;
}
.item:hover {
background: rgba(48, 64, 87, 0.8);
}
.calc {
width: 200px;
margin-bottom: 20px;
}
.loader {
border: 3px solid #f3f3f3;
border-radius: 50%;
border-top: 3px solid #3498db;
width: 15px;
height: 15px;
-webkit-animation: spin 2s linear infinite; /* Safari */
animation: spin 2s linear infinite;
position: relative;
margin-top: 12px;
margin-left: -15px;
}
/* Safari */
@-webkit-keyframes spin {
0% {
-webkit-transform: rotate(0deg);
}
100% {
-webkit-transform: rotate(360deg);
}
}
@keyframes spin {
0% {
transform: rotate(0deg);
}
100% {
transform: rotate(360deg);
}
}
</style>
